export const main_data =
{
  "datamain": [
/*   {
      "ID": 405,
      "StationCode": "43001",
      "StationName": "ХУТОР-МИХАЙЛОВСКИЙ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 52.04370396892563,
      "Lng": 33.94531568061544
  },
  {
      "ID": 406,
      "StationCode": "33000",
      "StationName": "ЖМЕРИНКА",
      "incomeCount": 63,
      "outgoingCount": 77,
      "Lat": 49.03481807370244,
      "Lng": 28.110414108258254
  },
  {
      "ID": 407,
      "StationCode": "33010",
      "StationName": "ВОЛОЧИСК",
      "incomeCount": 2,
      "outgoingCount": 0,
      "Lat": 49.531853802275435,
      "Lng": 26.208584628461864
  },
  {
      "ID": 408,
      "StationCode": "34841",
      "StationName": "ВЕРОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 50.76188004283307,
      "Lng": 27.917230133679
  },
  {
      "ID": 409,
      "StationCode": "35250",
      "StationName": "ИЗОВ",
      "incomeCount": 6,
      "outgoingCount": 75,
      "Lat": 50.82828578586614,
      "Lng": 24.059578806226057
  },
  {
      "ID": 410,
      "StationCode": "45170",
      "StationName": "ТЕРНОПОЛЬ",
      "incomeCount": 11,
      "outgoingCount": 21,
      "Lat": 49.55334708857535,
      "Lng": 25.60012108542756
  },
  {
      "ID": 411,
      "StationCode": "36100",
      "StationName": "СКАЛАТ",
      "incomeCount": 10,
      "outgoingCount": 0,
      "Lat": 49.4187929769013,
      "Lng": 25.96866800048815
  },
  {
      "ID": 412,
      "StationCode": "36120",
      "StationName": "МАКСИМОВКА-ТЕРНОПОЛЬСКАЯ",
      "incomeCount": 0,
      "outgoingCount": 46,
      "Lat": 49.59656387194147,
      "Lng": 25.90667800483905
  },
  {
      "ID": 413,
      "StationCode": "37020",
      "StationName": "ПОДЗАМЧЕ12",
      "incomeCount": 0,
      "outgoingCount": 5,
      "Lat": 49.85108707469606,
      "Lng": 24.036565278660788
  },
  {
      "ID": 414,
      "StationCode": "37040",
      "StationName": "КЛЕПАРОВ",
      "incomeCount": 0,
      "outgoingCount": 36,
      "Lat": 49.85560043351657,
      "Lng": 23.98057238002488
  },
  {
      "ID": 415,
      "StationCode": "37350",
      "StationName": "МОСТИСКА II",
      "incomeCount": 0,
      "outgoingCount": 121,
      "Lat": 49.81654199876792,
      "Lng": 23.032582347220934
  },
  {
      "ID": 416,
      "StationCode": "37860",
      "StationName": "ПЕРСЕНКОВКА",
      "incomeCount": 0,
      "outgoingCount": 1,
      "Lat": 49.80958542118307,
      "Lng": 24.030853917375257
  },
  {
      "ID": 417,
      "StationCode": "40150",
      "StationName": "РАУХОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.16948599307548,
      "Lng": 30.832024789611523
  },
  {
      "ID": 418,
      "StationCode": "40560",
      "StationName": "РАЗДЕЛЬНАЯ I",
      "incomeCount": 0,
      "outgoingCount": 52,
      "Lat": 46.85009933806273,
      "Lng": 30.073802778591418
  },
  {
      "ID": 419,
      "StationCode": "40570",
      "StationName": "РАЗДЕЛЬНАЯ-СОРТИРОВОЧНАЯ",
      "incomeCount": 0,
      "outgoingCount": 800,
      "Lat": 46.89250805601864,
      "Lng": 30.04455366791666
  },
  {
      "ID": 420,
      "StationCode": "40760",
      "StationName": "ПЕРВОМАЙСК-НА-БУГЕ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.041339407503784,
      "Lng": 30.85115531581459
  },
  {
      "ID": 421,
      "StationCode": "41000",
      "StationName": "ЗНАМЕНКА",
      "incomeCount": 84,
      "outgoingCount": 329,
      "Lat": 48.708815452158746,
      "Lng": 32.701438486025665
  },
  {
      "ID": 422,
      "StationCode": "41020",
      "StationName": "ПАНТАЕВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.67542880953508,
      "Lng": 32.884360698832694
  },
  {
      "ID": 423,
      "StationCode": "41030",
      "StationName": "КОРИСТОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.73163835094971,
      "Lng": 33.066955833433354
  },
  {
      "ID": 424,
      "StationCode": "41100",
      "StationName": "КОРОЛЕВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.5792952454247,
      "Lng": 33.224719006273915
  },
  {
      "ID": 425,
      "StationCode": "41110",
      "StationName": "ЧЕРНОЛЕССКАЯ",
      "incomeCount": 0,
      "outgoingCount": 106,
      "Lat": 48.748478087139546,
      "Lng": 32.52001580374082
  },
  {
      "ID": 426,
      "StationCode": "41130",
      "StationName": "КАНАТОВО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.58957698453216,
      "Lng": 32.38334062201784
  },
  {
      "ID": 427,
      "StationCode": "41170",
      "StationName": "ПЛЕТЕНЫЙ ТАШЛЫК",
      "incomeCount": 0,
      "outgoingCount": 53,
      "Lat": 48.4605058473723,
      "Lng": 31.727934368150557
  },
  {
      "ID": 428,
      "StationCode": "41190",
      "StationName": "ПОМОШНАЯ",
      "incomeCount": 15,
      "outgoingCount": 1,
      "Lat": 48.241772365953075,
      "Lng": 31.407455498163813
  },
  {
      "ID": 429,
      "StationCode": "41193",
      "StationName": "БЕШКЕТОВО (РЗД)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.18829152817233,
      "Lng": 31.378864363798073
  },
  {
      "ID": 431,
      "StationCode": "41270",
      "StationName": "КОЛОСОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.30865368765771,
      "Lng": 31.021254997579348
  },
  {
      "ID": 432,
      "StationCode": "41280",
      "StationName": "ВЕСЕЛИНОВО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.36207468638679,
      "Lng": 31.22638935104115
  },
  {
      "ID": 433,
      "StationCode": "45000",
      "StationName": "НИЖНЕДНЕПРОВСК-УЗЕЛ",
      "incomeCount": 77,
      "outgoingCount": 125,
      "Lat": 48.481550067807234,
      "Lng": 35.11832943135545
  },
  {
      "ID": 434,
      "StationCode": "45420",
      "StationName": "ЧАПЛИНО",
      "incomeCount": 2,
      "outgoingCount": 117,
      "Lat": 48.1265955483706,
      "Lng": 36.23451179300242
  },
  {
      "ID": 435,
      "StationCode": "45450",
      "StationName": "ПАВЛОГРАД I",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.55019073845918,
      "Lng": 35.856513813055244
  },
  {
      "ID": 436,
      "StationCode": "45460",
      "StationName": "АРОМАТНАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.628317739892225,
      "Lng": 35.888148100083384
  },
  {
      "ID": 437,
      "StationCode": "45600",
      "StationName": "ЗАПОРОЖЬЕ-КАМЕНСКОЕ",
      "incomeCount": 44,
      "outgoingCount": 24,
      "Lat": 48.48096407287565,
      "Lng": 34.64805309809597
  },
  {
      "ID": 438,
      "StationCode": "45640",
      "StationName": "ВЕРХОВЦЕВО",
      "incomeCount": 451,
      "outgoingCount": 49,
      "Lat": 48.4827670052002,
      "Lng": 34.23800096135787
  },
  {
      "ID": 439,
      "StationCode": "45720",
      "StationName": "РЯДОВАЯ",
      "incomeCount": 82,
      "outgoingCount": 107,
      "Lat": 48.229247379324306,
      "Lng": 33.534495485799624
  },
  {
      "ID": 440,
      "StationCode": "45730",
      "StationName": "ТЕРНЫ",
      "incomeCount": 7,
      "outgoingCount": 7,
      "Lat": 48.17840357339645,
      "Lng": 33.53482820278617
  },
  {
      "ID": 441,
      "StationCode": "45760",
      "StationName": "МУДРЕНАЯ",
      "incomeCount": 0,
      "outgoingCount": 1,
      "Lat": 47.91536813855589,
      "Lng": 33.39914722073769
  },
  {
      "ID": 442,
      "StationCode": "46000",
      "StationName": "ЗАПОРОЖЬЕ-ЛЕВОЕ",
      "incomeCount": 43,
      "outgoingCount": 120,
      "Lat": 47.878091309642656,
      "Lng": 35.22787370996298
  },
  {
      "ID": 443,
      "StationCode": "46060",
      "StationName": "ЗАПОРОЖЬЕ II",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.821941288505315,
      "Lng": 35.18455913309546
  },
  {
      "ID": 444,
      "StationCode": "46240",
      "StationName": "КАМЫШ-ЗАРЯ",
      "incomeCount": 45,
      "outgoingCount": 52,
      "Lat": 47.32878555386543,
      "Lng": 36.69444303210667
  },
  {
      "ID": 445,
      "StationCode": "46300",
      "StationName": "ПОЛОГИ",
      "incomeCount": 225,
      "outgoingCount": 47,
      "Lat": 47.47529066564774,
      "Lng": 36.261291680972676
  },
  {
      "ID": 446,
      "StationCode": "46310",
      "StationName": "ГУЛЯЙПОЛЕ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.64801339734598,
      "Lng": 36.16587241723301
  },
  {
      "ID": 447,
      "StationCode": "46360",
      "StationName": "РАСТУЩАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.80707385261858,
      "Lng": 35.2850656053736
  },
  {
      "ID": 448,
      "StationCode": "46720",
      "StationName": "КРИВОЙ РОГ",
      "incomeCount": 54,
      "outgoingCount": 108,
      "Lat": 47.912021598199686,
      "Lng": 33.45185802044881
  },
  {
      "ID": 449,
      "StationCode": "47600",
      "StationName": "МЕЛИТОПОЛЬ",
      "incomeCount": 105,
      "outgoingCount": 76,
      "Lat": 46.867892274675995,
      "Lng": 35.35637638700413
  },
  {
      "ID": 450,
      "StationCode": "47630",
      "StationName": "ФЕДОРОВКА",
      "incomeCount": 131,
      "outgoingCount": 62,
      "Lat": 47.080427941066176,
      "Lng": 35.314331355138734
  },
  {
      "ID": 451,
      "StationCode": "48190",
      "StationName": "УДАЧНАЯ",
      "incomeCount": 58,
      "outgoingCount": 58,
      "Lat": 48.23728380363633,
      "Lng": 36.98752820244101
  },
  {
      "ID": 452,
      "StationCode": "48200",
      "StationName": "ПОКРОВСК",
      "incomeCount": 15,
      "outgoingCount": 0,
      "Lat": 48.28379721818226,
      "Lng": 37.18196898069323
  },
  {
      "ID": 453,
      "StationCode": "48280",
      "StationName": "АВДЕЕВКА",
      "incomeCount": 1,
      "outgoingCount": 4,
      "Lat": 48.148353924521075,
      "Lng": 37.73313054905287
  },
  {
      "ID": 454,
      "StationCode": "48500",
      "StationName": "АСЛАНОВО",
      "incomeCount": 1,
      "outgoingCount": 0,
      "Lat": 47.24539581865725,
      "Lng": 37.58097252141883
  },
  {
      "ID": 455,
      "StationCode": "48560",
      "StationName": "МАРИУПОЛЬ-СОРТИРОВОЧНЫЙ",
      "incomeCount": 120,
      "outgoingCount": 126,
      "Lat": 47.203898707798345,
      "Lng": 37.55034558607204
  },
  {
      "ID": 456,
      "StationCode": "48620",
      "StationName": "ВОЛНОВАХА",
      "incomeCount": 445,
      "outgoingCount": 329,
      "Lat": 47.601559637493494,
      "Lng": 37.49025420024731
  },
  {
      "ID": 457,
      "StationCode": "48630",
      "StationName": "ВЕЛИКО-АНАДОЛЬ",
      "incomeCount": 161,
      "outgoingCount": 188,
      "Lat": 47.69792526999896,
      "Lng": 37.486914167145045
  },
  {
      "ID": 459,
      "StationCode": "41400",
      "StationName": "КУЦОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.31386260819274,
      "Lng": 32.79197238465739
  },
  {
      "ID": 460,
      "StationCode": "40580",
      "StationName": "КУЧУРГАН",
      "incomeCount": 1,
      "outgoingCount": 107,
      "Lat": 46.75402112565704,
      "Lng": 30.0023181520466
  },
  {
      "ID": 461,
      "StationCode": "41580",
      "StationName": "КУЧУРГАН (ЭКСП. НА НОВОСАВИЦКУЮ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.75356907858027,
      "Lng": 30.00201774657388
  },
  {
      "ID": 462,
      "StationCode": "40900",
      "StationName": "ЛАДЫЖИН",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.630939065673616,
      "Lng": 29.240192269534766
  },
  {
      "ID": 463,
      "StationCode": "41150",
      "StationName": "ЛЕЛЕКОВКА",
      "incomeCount": 0,
      "outgoingCount": 53,
      "Lat": 48.518690936026424,
      "Lng": 32.12418198302494
  },
  {
      "ID": 464,
      "StationCode": "42040",
      "StationName": "ЛИПОВЕЦ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.247440065046256,
      "Lng": 29.22928418489311
  },
  {
      "ID": 465,
      "StationCode": "41430",
      "StationName": "ЛОЦКИНО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.2020636340332,
      "Lng": 32.37517154066357
  },
  {
      "ID": 466,
      "StationCode": "42180",
      "StationName": "ЛЫСЯНКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.26532300549505,
      "Lng": 30.85103954071524
  },
  {
      "ID": 467,
      "StationCode": "40720",
      "StationName": "ЛЮБАШЕВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.84569728185341,
      "Lng": 30.26981448485773
  },
  {
      "ID": 468,
      "StationCode": "41350",
      "StationName": "ЛЮДМИЛОВКА",
      "incomeCount": 0,
      "outgoingCount": 38,
      "Lat": 48.03299564183149,
      "Lng": 31.44822895417724
  },
  {
      "ID": 469,
      "StationCode": "41050",
      "StationName": "МАРДАРОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.53557606408258,
      "Lng": 29.739951083000417
  },
  {
      "ID": 470,
      "StationCode": "41290",
      "StationName": "МАРТЫНОВСКАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.46848854830584,
      "Lng": 31.27889999834145
  },
  {
      "ID": 471,
      "StationCode": "42090",
      "StationName": "МОНАСТЫРИЩЕ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.00537592936201,
      "Lng": 29.715109540708724
  },
  {
      "ID": 472,
      "StationCode": "41250",
      "StationName": "НИКЕЛЬ-ПОБУЖСКИЙ",
      "incomeCount": 1,
      "outgoingCount": 0,
      "Lat": 48.163819102760385,
      "Lng": 30.61684364253695
  },
  {
      "ID": 473,
      "StationCode": "41510",
      "StationName": "НИКОЛАЕВ",
      "incomeCount": 54,
      "outgoingCount": 0,
      "Lat": 46.961938227113905,
      "Lng": 31.976146505827028
  },
  {
      "ID": 474,
      "StationCode": "48620",
      "StationName": "НИКОЛАЕВ-ГРУЗОВОЙ",
      "incomeCount": 11,
      "outgoingCount": 57,
      "Lat": 46.95773499765787,
      "Lng": 31.976132688534808
  },
  {
      "ID": 475,
      "StationCode": "41530",
      "StationName": "НИКОЛАЕВ-ГРУЗОВОЙ (ПЕРЕВ.) (ЭКСП.)(РЕЧ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.95795468224473,
      "Lng": 31.974855957092096
  },
  {
      "ID": 476,
      "StationCode": "41560",
      "StationName": "НИКОЛАЕВ-ГРУЗОВОЙ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.95808183396375,
      "Lng": 31.974905345435413
  },
  {
      "ID": 477,
      "StationCode": "40600",
      "StationName": "НОВОЗНАМЕНКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.880196719651856,
      "Lng": 38.12580379273259
  },
  {
      "ID": 478,
      "StationCode": "42350",
      "StationName": "НОВОМИРГОРОД",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.79476689607734,
      "Lng": 31.677865725360725
  },
  {
      "ID": 479,
      "StationCode": "41470",
      "StationName": "НОВОПОЛТАВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.53876382417374,
      "Lng": 32.51753884067181
  },
  {
      "ID": 480,
      "StationCode": "41180",
      "StationName": "НОВОУКРАИНКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.33290538604988,
      "Lng": 31.516657784657394
  },
  {
      "ID": 481,
      "StationCode": "41460",
      "StationName": "НОВЫЙ БУГ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.68598609883102,
      "Lng": 32.576590727182314
  },
  {
      "ID": 482,
      "StationCode": "42490",
      "StationName": "ОВИДИОПОЛЬ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.24734520812494,
      "Lng": 30.4485929136541
  },
  {
      "ID": 483,
      "StationCode": "40170",
      "StationName": "ОДЕССА-ЗАПАДНАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.43890960498893,
      "Lng": 30.653470627151822
  },
  {
      "ID": 484,
      "StationCode": "40510",
      "StationName": "ОДЕССА-ЗАСТАВА I",
      "incomeCount": 61,
      "outgoingCount": 45,
      "Lat": 46.47782287409754,
      "Lng": 30.654537511810187
  },
  {
      "ID": 485,
      "StationCode": "40410",
      "StationName": "ОДЕССА-ЗАСТАВА I (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.47780070932805,
      "Lng": 30.654569698317143
  },
  {
      "ID": 486,
      "StationCode": "40130",
      "StationName": "ОДЕССА-ЗАСТАВА II",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.463205393859674,
      "Lng": 30.684806727152324
  },
  {
      "ID": 487,
      "StationCode": "41990",
      "StationName": "ОДЕССА-ЛИСКИ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.52285385778497,
      "Lng": 30.60265735413992
  },
  {
      "ID": 488,
      "StationCode": "41980",
      "StationName": "ОДЕССА-ЛИСКИ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.52277265420135,
      "Lng": 30.60246423509816
  },
  {
      "ID": 489,
      "StationCode": "40080",
      "StationName": "ОДЕССА-ПЕРЕСЫПЬ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.525167615811974,
      "Lng": 30.72640226948268
  },
  {
      "ID": 490,
      "StationCode": "40070",
      "StationName": "ОДЕССА-ПЕРЕСЫПЬ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.52491663321457,
      "Lng": 30.72645591366095
  },
  {
      "ID": 491,
      "StationCode": "40030",
      "StationName": "ОДЕССА-ПОРТ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.48567056149315,
      "Lng": 30.748811540646
  },
  {
      "ID": 492,
      "StationCode": "40040",
      "StationName": "ОДЕССА-ПОРТ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.485840466583305,
      "Lng": 30.748135623999858
  },
  {
      "ID": 493,
      "StationCode": "40000",
      "StationName": "ОДЕССА-СОРТИРОВОЧНАЯ",
      "incomeCount": 6,
      "outgoingCount": 1,
      "Lat": 46.55433064714823,
      "Lng": 30.754330625305062
  },
  {
      "ID": 494,
      "StationCode": "40290",
      "StationName": "ОДЕССА-СОРТИРОВОЧНАЯ (ЭКСП)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.5544855819925,
      "Lng": 30.753590335645008
  },
  {
      "ID": 495,
      "StationCode": "40020",
      "StationName": "ОДЕССА-ТОВАРНАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.45548737030766,
      "Lng": 30.71127218482352
  },
  {
      "ID": 496,
      "StationCode": "41080",
      "StationName": "ОДЕССА-ТОВАРНАЯ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.45579780348196,
      "Lng": 30.713825647708937
  },
  {
      "ID": 497,
      "StationCode": "41870",
      "StationName": "ОЛЕШКИ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.64309734088596,
      "Lng": 32.83432899772855
  },
  {
      "ID": 498,
      "StationCode": "42050",
      "StationName": "ОРАТОВ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.175467313670794,
      "Lng": 29.39154628489116
  },
  {
      "ID": 499,
      "StationCode": "41260",
      "StationName": "ОРЛИК",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.04986610871954,
      "Lng": 30.922619184862754
  },
  {
      "ID": 500,
      "StationCode": "40980",
      "StationName": "ОСИПОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.25717667963462,
      "Lng": 30.73706981223446
  },
  {
      "ID": 501,
      "StationCode": "41550",
      "StationName": "ОСТ. ПУНКТ 121 КМ (ЭКСП)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.66948908438543,
      "Lng": 28.50513205448904
  },
  {
      "ID": 502,
      "StationCode": "41090",
      "StationName": "ПАВЛЫШ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.912116607450606,
      "Lng": 33.33847025419923
  },
  {
      "ID": 503,
      "StationCode": "42470",
      "StationName": "ПАЛЬМИРА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.76112938270072,
      "Lng": 32.153109998399344
  },
  {
      "ID": 504,
      "StationCode": "40250",
      "StationName": "ПАРОМНАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.40291382381937,
      "Lng": 30.6555080506361
  },
  {
      "ID": 505,
      "StationCode": "41920",
      "StationName": "ПАРОМНАЯ (ПРОЧИЙ ЭКСПОРТ ТУРЦИЯ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.39769229596745,
      "Lng": 30.656597435818515
  },
  {
      "ID": 506,
      "StationCode": "41970",
      "StationName": "ПАРОМНАЯ (ПРОЧИЙ ЭКСПОРТ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.39782907343334,
      "Lng": 30.65600244753253
  },
  {
      "ID": 507,
      "StationCode": "40220",
      "StationName": "ПАРОМНАЯ-ЭКСПОРТ (БАТУМИ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.397008403495384,
      "Lng": 30.656795765247175
  },
  {
      "ID": 508,
      "StationCode": "40260",
      "StationName": "ПАРОМНАЯ-ЭКСПОРТ (БОЛГАРИЯ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.398376179868286,
      "Lng": 30.656597435818515
  },
  {
      "ID": 509,
      "StationCode": "40400",
      "StationName": "ПАРОМНАЯ-ЭКСПОРТ (ПОТИ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.39235770737472,
      "Lng": 30.65778741239049
  },
  {
      "ID": 510,
      "StationCode": "40270",
      "StationName": "ПАРОМНАЯ-ЭКСПОРТ (РЫБНЫЙ ПОРТ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.39248837019063,
      "Lng": 30.657513680671475
  },
  {
      "ID": 511,
      "StationCode": "40180",
      "StationName": "ПАРОМНАЯ-ЭКСПОРТ (ТУРЦИЯ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.4228924706349,
      "Lng": 30.65424742590947
  },
  {
      "ID": 512,
      "StationCode": "42280",
      "StationName": "ПЕРЕГОНОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.22178820776062,
      "Lng": 31.76411835605668
  },
  {
      "ID": 513,
      "StationCode": "42390",
      "StationName": "ПЕТРОСТАЛЬ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.45096855918756,
      "Lng": 28.961036007500645
  },
  {
      "ID": 514,
      "StationCode": "41230",
      "StationName": "ПОДГОРОДНАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.109572536582625,
      "Lng": 30.89364470205649
  },
  {
      "ID": 515,
      "StationCode": "40680",
      "StationName": "ПОДОЛЬСК",
      "incomeCount": 0,
      "outgoingCount": 253,
      "Lat": 47.75014219841927,
      "Lng": 29.529057656019685
  },
  {
      "ID": 516,
      "StationCode": "40820",
      "StationName": "ПОПЕЛЮХИ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.215248151306334,
      "Lng": 28.976198642538236
  },
  {
      "ID": 517,
      "StationCode": "42130",
      "StationName": "ПОТАШ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.92033912973358,
      "Lng": 30.32852635604911
  },
  {
      "ID": 518,
      "StationCode": "41740",
      "StationName": "ПРИБУГСКАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.862326384220346,
      "Lng": 32.040709827162026
  },
  {
      "ID": 519,
      "StationCode": "41830",
      "StationName": "ПРИБУГСКАЯ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.8625537960657,
      "Lng": 32.04241571203085
  },
  {
      "ID": 520,
      "StationCode": "41880",
      "StationName": "РАДЕНСКОЕ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.56399501653135,
      "Lng": 32.94395372715484
  },
  {
      "ID": 521,
      "StationCode": "41590",
      "StationName": "РАЗДЕЛЬНАЯ I (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.85035406722796,
      "Lng": 30.073609998326138
  },
  {
      "ID": 522,
      "StationCode": "40470",
      "StationName": "РЕНИ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.45812601547738,
      "Lng": 28.265954828977872
  },
  {
      "ID": 523,
      "StationCode": "40480",
      "StationName": "РЕНИ (НАЛИВ.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.458269000386366,
      "Lng": 28.26503214911171
  },
  {
      "ID": 524,
      "StationCode": "40340",
      "StationName": "РЕНИ (ЭКСП. ЧФР)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.45865280019136,
      "Lng": 28.264152384588165
  },
  {
      "ID": 525,
      "StationCode": "40350",
      "StationName": "РЕНИ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.4584797143282,
      "Lng": 28.264613724521247
  },
  {
      "ID": 526,
      "StationCode": "40490",
      "StationName": "РЕНИ-ПОРТ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.45607335357874,
      "Lng": 28.26944442704474
  },
  {
      "ID": 527,
      "StationCode": "40610",
      "StationName": "РОТОВО (РЗД)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.99108298132374,
      "Lng": 30.450117169494018
  },
  {
      "ID": 528,
      "StationCode": "40830",
      "StationName": "РУДНИЦА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.26076759444695,
      "Lng": 28.934825033060637
  },
  {
      "ID": 529,
      "StationCode": "40380",
      "StationName": "САРАТА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.01618115408009,
      "Lng": 29.678985627141547
  },
  {
      "ID": 530,
      "StationCode": "41370",
      "StationName": "САХАРНАЯ",
      "incomeCount": 0,
      "outgoingCount": 60,
      "Lat": 48.64294138460013,
      "Lng": 32.62599364254902
  },
  {
      "ID": 531,
      "StationCode": "42330",
      "StationName": "СЕРДЮКОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.03812898054366,
      "Lng": 31.798618998380764
  },
  {
      "ID": 532,
      "StationCode": "41710",
      "StationName": "СЕРОГОЗЫ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.94246310257098,
      "Lng": 34.374587811821456
  },
  {
      "ID": 533,
      "StationCode": "42210",
      "StationName": "СИГНАЕВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.05758712862784,
      "Lng": 31.49764601187441
  },
  {
      "ID": 534,
      "StationCode": "40790",
      "StationName": "СЛОБОДКА",
      "incomeCount": 48,
      "outgoingCount": 72,
      "Lat": 47.88405086220159,
      "Lng": 29.346104069516105
  },
  {
      "ID": 535,
      "StationCode": "41820",
      "StationName": "СЛОБОДКА (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.884604882924485,
      "Lng": 29.344408913482926
  },
  {
      "ID": 536,
      "StationCode": "42400",
      "StationName": "СМЕЛА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.24444705527529,
      "Lng": 31.8760843574617
  },
  {
      "ID": 537,
      "StationCode": "41610",
      "StationName": "СНИГИРЕВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.065353973689255,
      "Lng": 32.78090776949578
  },
  {
      "ID": 538,
      "StationCode": "42070",
      "StationName": "СОРОКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.07159080990604,
      "Lng": 29.36097654071025
  },
  {
      "ID": 539,
      "StationCode": "41060",
      "StationName": "СЧАСТЛИВАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.59417028175827,
      "Lng": 33.39455354254785
  },
  {
      "ID": 540,
      "StationCode": "42270",
      "StationName": "ТАГАНЧА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.62311083597882,
      "Lng": 31.024984184902724
  },
  {
      "ID": 541,
      "StationCode": "42140",
      "StationName": "ТАЛЬНОЕ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.895376317692325,
      "Lng": 30.72432135604824
  },
  {
      "ID": 542,
      "StationCode": "41200",
      "StationName": "ТАУЖНЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.376796518945866,
      "Lng": 30.104472369528224
  },
  {
      "ID": 543,
      "StationCode": "41940",
      "StationName": "ТЕРНОВКА-НИКОЛАЕВСКАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 47.05811170662728,
      "Lng": 31.955258082988596
  },*/
  {
      "ID": 544,
      "StationCode": "41120",
      "StationName": "ТРЕПОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.68521599150582,
      "Lng": 32.3668314100152
  },
  {
      "ID": 545,
      "StationCode": "41320",
      "StationName": "ТРИКРАТНОЕ",
      "incomeCount": 0,
      "outgoingCount": 53,
      "Lat": 47.70565375342228,
      "Lng": 31.30527635416906
  },
  {
      "ID": 546,
      "StationCode": "40890",
      "StationName": "ТРОСТЯНЕЦ-ПОДОЛЬСКИЙ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.514110229892786,
      "Lng": 29.210795269531832
  },
  {
      "ID": 547,
      "StationCode": "42120",
      "StationName": "УМАНЬ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.733125365712965,
      "Lng": 30.204515025359218
  },
  {
      "ID": 548,
      "StationCode": "40520",
      "StationName": "УСАТОВО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.52606801158302,
      "Lng": 30.605377169314785
  },
  {
      "ID": 549,
      "StationCode": "40280",
      "StationName": "ФРИКАЦЕЙ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.57387812588536,
      "Lng": 30.61051510501235
  },
  {
      "ID": 550,
      "StationCode": "40620",
      "StationName": "ФРИКАЦЕЙ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 45.49104583189243,
      "Lng": 28.413186229870806
  },
  {
      "ID": 551,
      "StationCode": "42310",
      "StationName": "ФУНДУКЛЕЕВКА",
      "incomeCount": 0,
      "outgoingCount": 48,
      "Lat": 48.97458801102679,
      "Lng": 32.25018744070781
  },
  {
      "ID": 552,
      "StationCode": "41780",
      "StationName": "ХЕРСОН",
      "incomeCount": 1,
      "outgoingCount": 0,
      "Lat": 46.65764097118672,
      "Lng": 32.60484067191799
  },
  {
      "ID": 553,
      "StationCode": "41860",
      "StationName": "ХЕРСОН (ЭКСП.)(МОРСКОЙ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.63118372079142,
      "Lng": 32.56836263069772
  },
  {
      "ID": 554,
      "StationCode": "41850",
      "StationName": "ХЕРСОН (ЭКСП.)(ТРУБОПРОВОД)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.628885041504475,
      "Lng": 32.570765889883994
  },
  {
      "ID": 555,
      "StationCode": "41790",
      "StationName": "ХЕРСОН-ПОРТ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.62929763215488,
      "Lng": 32.56741849316025
  },
  {
      "ID": 556,
      "StationCode": "41840",
      "StationName": "ХЕРСОН-ПОРТ (ПЕРЕВ.)(ЭКСП.)(РЕЧНОЙ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.61958775030816,
      "Lng": 32.57384511229538
  },
  {
      "ID": 557,
      "StationCode": "41800",
      "StationName": "ХЕРСОН-ПОРТ (ЭКСП.)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.65430962243433,
      "Lng": 32.59624064215671
  },
  {
      "ID": 558,
      "StationCode": "42250",
      "StationName": "ХЛЫСТУНОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.200435239153165,
      "Lng": 31.46363491372752
  },
  {
      "ID": 559,
      "StationCode": "40990",
      "StationName": "ХОЩЕВАТО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.317429616777005,
      "Lng": 29.94946854069135
  },
  {
      "ID": 560,
      "StationCode": "42110",
      "StationName": "ХРИСТИНОВКА",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.81540965889674,
      "Lng": 29.97262889837519
  },
  {
      "ID": 561,
      "StationCode": "42260",
      "StationName": "ЦВЕТКОВО",
      "incomeCount": 0,
      "outgoingCount": 103,
      "Lat": 49.154328486422926,
      "Lng": 31.529622515342613
  },
  {
      "ID": 562,
      "StationCode": "42320",
      "StationName": "ЦЫБУЛЕВО",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 48.84466349276472,
      "Lng": 32.41202493068522
  },
  {
      "ID": 563,
      "StationCode": "41360",
      "StationName": "ЧЕРВОНОЕ ОЗЕРО (РЗД)",
      "incomeCount": 0,
      "outgoingCount": 53,
      "Lat": 48.10594492120497,
      "Lng": 32.66978264253542
  },
  {
      "ID": 564,
      "StationCode": "42420",
      "StationName": "ЧЕРКАССЫ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 49.426151351363714,
      "Lng": 32.04981652537677
  },
  {
      "ID": 565,
      "StationCode": "40200",
      "StationName": "ЧЕРНОМОРСК-ПОРТ",
      "incomeCount": 46,
      "outgoingCount": 0,
      "Lat": 46.3232847736067,
      "Lng": 30.63599622799975
  },
  {
      "ID": 566,
      "StationCode": "43000",
      "StationName": "ЧЕРНОМОРСК-ПОРТ-ЭКСПОРТ",
      "incomeCount": 6,
      "outgoingCount": 0,
      "Lat": 46.3359533089847,
      "Lng": 30.67016883035348
  },
  {
      "ID": 567,
      "StationCode": "40110",
      "StationName": "ЧЕРНОМОРСКАЯ",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.8279901967526,
      "Lng": 30.76010655784659
  },
  {
      "ID": 568,
      "StationCode": "40010",
      "StationName": "ЧЕРНОМОРСКАЯ (ДЛЯ ТИС)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.82873158940544,
      "Lng": 30.759334081679572
  },
  {
      "ID": 569,
      "StationCode": "40300",
      "StationName": "ЧЕРНОМОРСКАЯ (ЭКСП. ДЛЯ ТИС )",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.82693314399977,
      "Lng": 30.76010655784659
  },
  {
      "ID": 570,
      "StationCode": "42440",
      "StationName": "ЧЕРНОМОРСКАЯ(ДЛЯ ОПЗ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.82917201584247,
      "Lng": 30.7589156570891
  },
  {
      "ID": 571,
      "StationCode": "42460",
      "StationName": "ЧЕРНОМОРСКАЯ-ЭКСП.(ДЛЯ ОПЗ)",
      "incomeCount": 0,
      "outgoingCount": 0,
      "Lat": 46.83183651885783,
      "Lng": 30.757381433540715
  },
  
  ],

  "subdata": [
    {
        "ID": 7505675,
        "nomv": 52228830,
        "dor": "ЮГО-ЗАПАДНАЯ  ",
        "indp": "03300+003+03941",
        "kodstdis": "41120",
        "nazvstdis": "МИРОПОЛЬ",
        "datop": "2022-06-03T14:35:00",
        "oper": "ПРОС",
        "kodgruza": "23311",
        "nazvgruza": "ИЗВЕСТЬ НЕГАШЕНАЯ",
        "kodhex": "#FF0000",
        "nazvpol": "(ДН-3) \"Р.Ф-Я \"ПРИДН.ЗАЛ.\" ПАТ \"УКРЗАЛІЗНИЦЯ\"",
        "nazvotpr": "ТОВ \"ГАЛТЕХНОПАРК\"",
        "kodpol": "5068",
        "kodotpr": "5528",
        "kodstnazn": "46000",
        "napr": 1,
        "createdate": "2022-06-03T16:00:02.423"
      },
      {
        "ID": 7505676,
        "nomv": 52228830,
        "dor": "ЮГО-ЗАПАДНАЯ  ",
        "indp": "34270+115+00050",
        "kodstdis": "41120",
        "nazvstdis": "МИРОПОЛЬ",
        "datop": "2022-06-29T14:35:00",
        "oper": "ПРОС",
        "kodgruza": "23311",
        "nazvgruza": "ИЗВЕСТЬ НЕГАШЕНАЯ",
        "kodhex": "#FF0000",
        "nazvpol": "(ДН-3) \"Р.Ф-Я \"ПРИДН.ЗАЛ.\" ПАТ \"УКРЗАЛІЗНИЦЯ\"",
        "nazvotpr": "ТОВ \"ГАЛТЕХНОПАРК\"",
        "kodpol": "6004",
        "kodotpr": "5068",
        "kodstnazn": "46000",
        "napr": 2,
        "createdate": "2022-06-03T16:00:02.423"
      },
      {
        "ID": 7505677,
        "nomv": 56850712,
        "dor": "ЛЬВОВСКАЯ  ",
        "indp": "34270+115+00050",
        "kodstdis": "36000",
        "nazvstdis": "ТЕРНОПОЛЬ",
        "datop": "2022-06-03T14:10:00",
        "oper": "ПРИБ",
        "kodgruza": "29102",
        "nazvgruza": "ДОЛОМИТ СЫРОЙ МЕТАЛЛУРГИЧЕСКИЙ",
        "kodhex": "#FFD700",
        "nazvpol": "(ДН-1) \"Р.Ф-Я \"ПРИДН. ЗАЛ.\"ПАТ \"УКРЗАЛІЗНИЦЯ\"",
        "nazvotpr": "ТОВ ВК \"ГІРНИЧОДОБУВНА ПРОМИСЛОВІСТЬ\"",
        "kodpol": "5068",
        "kodotpr": "3700",
        "kodstnazn": "45580",
        "napr": 1,
        "createdate": "2022-06-03T16:00:02.423"
      },
      {
        "ID": 7505678,
        "nomv": 52228830,
        "dor": "ЮГО-ЗАПАДНАЯ  ",
        "indp": "34270+115+00051",
        "kodstdis": "41120",
        "nazvstdis": "МИРОПОЛЬ",
        "datop": "2022-06-29T14:35:00",
        "oper": "ПРОС",
        "kodgruza": "23315",
        "nazvgruza": "ДОЛОМИТ",
        "kodhex": "#008000",
        "nazvpol": "(ДН-3) \"Р.Ф-Я \"ПРИДН.ЗАЛ.\" ПАТ \"УКРЗАЛІЗНИЦЯ\"",
        "nazvotpr": "ТОВ \"ГАЛТЕХНОПАРК\"",
        "kodpol": "6004",
        "kodotpr": "5068",
        "kodstnazn": "46000",
        "napr": 2,
        "createdate": "2022-06-03T16:00:02.423"
      },
],
  "picklists": [
    {
        "name": "Kodstdis",
        "masterkey": "id",
        "rows": [
            {
                "id": 40450,
                "title": "40450",
                "pk_id": "40450"
            },
            {
                "id": 46520,
                "title": "46520",
                "pk_id": "46520"
            },
            {
                "id": 45590,
                "title": "45590",
                "pk_id": "45590"
            },
            {
                "id": 46000,
                "title": "46000",
                "pk_id": "46000"
            },
            {
                "id": 34370,
                "title": "34370",
                "pk_id": "34370"
            },
            {
                "id": 46730,
                "title": "46730",
                "pk_id": "46730"
            },
            {
                "id": 38170,
                "title": "38170",
                "pk_id": "38170"
            },
            {
                "id": 34240,
                "title": "34240",
                "pk_id": "34240"
            },
            {
                "id": 34640,
                "title": "34640",
                "pk_id": "34640"
            },
            {
                "id": 41030,
                "title": "41030",
                "pk_id": "41030"
            },
            {
                "id": 46350,
                "title": "46350",
                "pk_id": "46350"
            },
            {
                "id": 49870,
                "title": "49870",
                "pk_id": "49870"
            },
            {
                "id": 49290,
                "title": "49290",
                "pk_id": "49290"
            },
            {
                "id": 46700,
                "title": "46700",
                "pk_id": "46700"
            },
            {
                "id": 38250,
                "title": "38250",
                "pk_id": "38250"
            },
            {
                "id": 47680,
                "title": "47680",
                "pk_id": "47680"
            },
            {
                "id": 37860,
                "title": "37860",
                "pk_id": "37860"
            },
            {
                "id": 47630,
                "title": "47630",
                "pk_id": "47630"
            },
            {
                "id": 45740,
                "title": "45740",
                "pk_id": "45740"
            },
            {
                "id": 34600,
                "title": "34600",
                "pk_id": "34600"
            },
            {
                "id": 40390,
                "title": "40390",
                "pk_id": "40390"
            },
            {
                "id": 45110,
                "title": "45110",
                "pk_id": "45110"
            },
            {
                "id": 48200,
                "title": "48200",
                "pk_id": "48200"
            },
            {
                "id": 38220,
                "title": "38220",
                "pk_id": "38220"
            },
            {
                "id": 38030,
                "title": "38030",
                "pk_id": "38030"
            },
            {
                "id": 34190,
                "title": "34190",
                "pk_id": "34190"
            },
            {
                "id": 48230,
                "title": "48230",
                "pk_id": "48230"
            },
            {
                "id": 45360,
                "title": "45360",
                "pk_id": "45360"
            },
            {
                "id": 45750,
                "title": "45750",
                "pk_id": "45750"
            },
            {
                "id": 46600,
                "title": "46600",
                "pk_id": "46600"
            },
            {
                "id": 37709,
                "title": "37709",
                "pk_id": "37709"
            },
            {
                "id": 37570,
                "title": "37570",
                "pk_id": "37570"
            },
            {
                "id": 45700,
                "title": "45700",
                "pk_id": "45700"
            },
            {
                "id": 35940,
                "title": "35940",
                "pk_id": "35940"
            },
            {
                "id": 38360,
                "title": "38360",
                "pk_id": "38360"
            },
            {
                "id": 40810,
                "title": "40810",
                "pk_id": "40810"
            },
            {
                "id": 45200,
                "title": "45200",
                "pk_id": "45200"
            },
            {
                "id": 35000,
                "title": "35000",
                "pk_id": "35000"
            },
            {
                "id": 40660,
                "title": "40660",
                "pk_id": "40660"
            },
            {
                "id": 40170,
                "title": "40170",
                "pk_id": "40170"
            },
            {
                "id": 41410,
                "title": "41410",
                "pk_id": "41410"
            },
            {
                "id": 41750,
                "title": "41750",
                "pk_id": "41750"
            },
            {
                "id": 37040,
                "title": "37040",
                "pk_id": "37040"
            },
            {
                "id": 46710,
                "title": "46710",
                "pk_id": "46710"
            },
            {
                "id": 37690,
                "title": "37690",
                "pk_id": "37690"
            },
            {
                "id": 35850,
                "title": "35850",
                "pk_id": "35850"
            },
            {
                "id": 45170,
                "title": "45170",
                "pk_id": "45170"
            },
            {
                "id": 46660,
                "title": "46660",
                "pk_id": "46660"
            },
            {
                "id": 34440,
                "title": "34440",
                "pk_id": "34440"
            },
            {
                "id": 40720,
                "title": "40720",
                "pk_id": "40720"
            },
            {
                "id": 45610,
                "title": "45610",
                "pk_id": "45610"
            },
            {
                "id": 41250,
                "title": "41250",
                "pk_id": "41250"
            },
            {
                "id": 40020,
                "title": "40020",
                "pk_id": "40020"
            },
            {
                "id": 40530,
                "title": "40530",
                "pk_id": "40530"
            },
            {
                "id": 40595,
                "title": "40595",
                "pk_id": "40595"
            },
            {
                "id": 41351,
                "title": "41351",
                "pk_id": "41351"
            },
            {
                "id": 34112,
                "title": "34112",
                "pk_id": "34112"
            },
            {
                "id": 41060,
                "title": "41060",
                "pk_id": "41060"
            },
            {
                "id": 37670,
                "title": "37670",
                "pk_id": "37670"
            },
            {
                "id": 41193,
                "title": "41193",
                "pk_id": "41193"
            },
            {
                "id": 49310,
                "title": "49310",
                "pk_id": "49310"
            },
            {
                "id": 34260,
                "title": "34260",
                "pk_id": "34260"
            },
            {
                "id": 40760,
                "title": "40760",
                "pk_id": "40760"
            },
            {
                "id": 46720,
                "title": "46720",
                "pk_id": "46720"
            },
            {
                "id": 34630,
                "title": "34630",
                "pk_id": "34630"
            },
            {
                "id": 48500,
                "title": "48500",
                "pk_id": "48500"
            },
            {
                "id": 41520,
                "title": "41520",
                "pk_id": "41520"
            },
            {
                "id": 40790,
                "title": "40790",
                "pk_id": "40790"
            },
            {
                "id": 33080,
                "title": "33080",
                "pk_id": "33080"
            },
            {
                "id": 38370,
                "title": "38370",
                "pk_id": "38370"
            },
            {
                "id": 33060,
                "title": "33060",
                "pk_id": "33060"
            },
            {
                "id": 41140,
                "title": "41140",
                "pk_id": "41140"
            },
            {
                "id": 42410,
                "title": "42410",
                "pk_id": "42410"
            },
            {
                "id": 40540,
                "title": "40540",
                "pk_id": "40540"
            },
            {
                "id": 46190,
                "title": "46190",
                "pk_id": "46190"
            },
            {
                "id": 40580,
                "title": "40580",
                "pk_id": "40580"
            },
            {
                "id": 48280,
                "title": "48280",
                "pk_id": "48280"
            },
            {
                "id": 48560,
                "title": "48560",
                "pk_id": "48560"
            },
            {
                "id": 46760,
                "title": "46760",
                "pk_id": "46760"
            },
            {
                "id": 36050,
                "title": "36050",
                "pk_id": "36050"
            },
            {
                "id": 36660,
                "title": "36660",
                "pk_id": "36660"
            },
            {
                "id": 45002,
                "title": "45002",
                "pk_id": "45002"
            },
            {
                "id": 35880,
                "title": "35880",
                "pk_id": "35880"
            },
            {
                "id": 38850,
                "title": "38850",
                "pk_id": "38850"
            },
            {
                "id": 33010,
                "title": "33010",
                "pk_id": "33010"
            },
            {
                "id": 42260,
                "title": "42260",
                "pk_id": "42260"
            },
            {
                "id": 44020,
                "title": "44020",
                "pk_id": "44020"
            },
            {
                "id": 35090,
                "title": "35090",
                "pk_id": "35090"
            },
            {
                "id": 38240,
                "title": "38240",
                "pk_id": "38240"
            },
            {
                "id": 40850,
                "title": "40850",
                "pk_id": "40850"
            },
            {
                "id": 38470,
                "title": "38470",
                "pk_id": "38470"
            },
            {
                "id": 46070,
                "title": "46070",
                "pk_id": "46070"
            },
            {
                "id": 34000,
                "title": "34000",
                "pk_id": "34000"
            },
            {
                "id": 41110,
                "title": "41110",
                "pk_id": "41110"
            },
            {
                "id": 37523,
                "title": "37523",
                "pk_id": "37523"
            },
            {
                "id": 40510,
                "title": "40510",
                "pk_id": "40510"
            },
            {
                "id": 37780,
                "title": "37780",
                "pk_id": "37780"
            },
            {
                "id": 35321,
                "title": "35321",
                "pk_id": "35321"
            },
            {
                "id": 34710,
                "title": "34710",
                "pk_id": "34710"
            },
            {
                "id": 32070,
                "title": "32070",
                "pk_id": "32070"
            },
            {
                "id": 41190,
                "title": "41190",
                "pk_id": "41190"
            },
            {
                "id": 43000,
                "title": "43000",
                "pk_id": "43000"
            },
            {
                "id": 33170,
                "title": "33170",
                "pk_id": "33170"
            },
            {
                "id": 48590,
                "title": "48590",
                "pk_id": "48590"
            },
            {
                "id": 36090,
                "title": "36090",
                "pk_id": "36090"
            },
            {
                "id": 40000,
                "title": "40000",
                "pk_id": "40000"
            },
            {
                "id": 35080,
                "title": "35080",
                "pk_id": "35080"
            },
            {
                "id": 33115,
                "title": "33115",
                "pk_id": "33115"
            },
            {
                "id": 36330,
                "title": "36330",
                "pk_id": "36330"
            },
            {
                "id": 38440,
                "title": "38440",
                "pk_id": "38440"
            },
            {
                "id": 37790,
                "title": "37790",
                "pk_id": "37790"
            },
            {
                "id": 42310,
                "title": "42310",
                "pk_id": "42310"
            },
            {
                "id": 46240,
                "title": "46240",
                "pk_id": "46240"
            },
            {
                "id": 48460,
                "title": "48460",
                "pk_id": "48460"
            },
            {
                "id": 33580,
                "title": "33580",
                "pk_id": "33580"
            },
            {
                "id": 48190,
                "title": "48190",
                "pk_id": "48190"
            },
            {
                "id": 36440,
                "title": "36440",
                "pk_id": "36440"
            },
            {
                "id": 32010,
                "title": "32010",
                "pk_id": "32010"
            },
            {
                "id": 32000,
                "title": "32000",
                "pk_id": "32000"
            },
            {
                "id": 41422,
                "title": "41422",
                "pk_id": "41422"
            },
            {
                "id": 46300,
                "title": "46300",
                "pk_id": "46300"
            },
            {
                "id": 42000,
                "title": "42000",
                "pk_id": "42000"
            },
            {
                "id": 45600,
                "title": "45600",
                "pk_id": "45600"
            },
            {
                "id": 34140,
                "title": "34140",
                "pk_id": "34140"
            },
            {
                "id": 40320,
                "title": "40320",
                "pk_id": "40320"
            },
            {
                "id": 41424,
                "title": "41424",
                "pk_id": "41424"
            },
            {
                "id": 41074,
                "title": "41074",
                "pk_id": "41074"
            },
            {
                "id": 45702,
                "title": "45702",
                "pk_id": "45702"
            },
            {
                "id": 34410,
                "title": "34410",
                "pk_id": "34410"
            },
            {
                "id": 37520,
                "title": "37520",
                "pk_id": "37520"
            },
            {
                "id": 46620,
                "title": "46620",
                "pk_id": "46620"
            },
            {
                "id": 45710,
                "title": "45710",
                "pk_id": "45710"
            },
            {
                "id": 40080,
                "title": "40080",
                "pk_id": "40080"
            },
            {
                "id": 41130,
                "title": "41130",
                "pk_id": "41130"
            },
            {
                "id": 41000,
                "title": "41000",
                "pk_id": "41000"
            },
            {
                "id": 48620,
                "title": "48620",
                "pk_id": "48620"
            },
            {
                "id": 42240,
                "title": "42240",
                "pk_id": "42240"
            },
            {
                "id": 36000,
                "title": "36000",
                "pk_id": "36000"
            },
            {
                "id": 35900,
                "title": "35900",
                "pk_id": "35900"
            },
            {
                "id": 40110,
                "title": "40110",
                "pk_id": "40110"
            },
            {
                "id": 45730,
                "title": "45730",
                "pk_id": "45730"
            },
            {
                "id": 49090,
                "title": "49090",
                "pk_id": "49090"
            },
            {
                "id": 42005,
                "title": "42005",
                "pk_id": "42005"
            },
            {
                "id": 35780,
                "title": "35780",
                "pk_id": "35780"
            },
            {
                "id": 46270,
                "title": "46270",
                "pk_id": "46270"
            },
            {
                "id": 45682,
                "title": "45682",
                "pk_id": "45682"
            },
            {
                "id": 38100,
                "title": "38100",
                "pk_id": "38100"
            },
            {
                "id": 33040,
                "title": "33040",
                "pk_id": "33040"
            },
            {
                "id": 33300,
                "title": "33300",
                "pk_id": "33300"
            },
            {
                "id": 49600,
                "title": "49600",
                "pk_id": "49600"
            },
            {
                "id": 37740,
                "title": "37740",
                "pk_id": "37740"
            },
            {
                "id": 40195,
                "title": "40195",
                "pk_id": "40195"
            },
            {
                "id": 45680,
                "title": "45680",
                "pk_id": "45680"
            },
            {
                "id": 38530,
                "title": "38530",
                "pk_id": "38530"
            },
            {
                "id": 37580,
                "title": "37580",
                "pk_id": "37580"
            },
            {
                "id": 35550,
                "title": "35550",
                "pk_id": "35550"
            },
            {
                "id": 40680,
                "title": "40680",
                "pk_id": "40680"
            },
            {
                "id": 35660,
                "title": "35660",
                "pk_id": "35660"
            },
            {
                "id": 36360,
                "title": "36360",
                "pk_id": "36360"
            },
            {
                "id": 34807,
                "title": "34807",
                "pk_id": "34807"
            },
            {
                "id": 35490,
                "title": "35490",
                "pk_id": "35490"
            },
            {
                "id": 33100,
                "title": "33100",
                "pk_id": "33100"
            },
            {
                "id": 34100,
                "title": "34100",
                "pk_id": "34100"
            },
            {
                "id": 46692,
                "title": "46692",
                "pk_id": "46692"
            },
            {
                "id": 37000,
                "title": "37000",
                "pk_id": "37000"
            },
            {
                "id": 34160,
                "title": "34160",
                "pk_id": "34160"
            },
            {
                "id": 37060,
                "title": "37060",
                "pk_id": "37060"
            },
            {
                "id": 33070,
                "title": "33070",
                "pk_id": "33070"
            },
            {
                "id": 40820,
                "title": "40820",
                "pk_id": "40820"
            },
            {
                "id": 37021,
                "title": "37021",
                "pk_id": "37021"
            },
            {
                "id": 45640,
                "title": "45640",
                "pk_id": "45640"
            },
            {
                "id": 35400,
                "title": "35400",
                "pk_id": "35400"
            },
            {
                "id": 47600,
                "title": "47600",
                "pk_id": "47600"
            },
            {
                "id": 40750,
                "title": "40750",
                "pk_id": "40750"
            },
            {
                "id": 45000,
                "title": "45000",
                "pk_id": "45000"
            },
            {
                "id": 35250,
                "title": "35250",
                "pk_id": "35250"
            },
            {
                "id": 36470,
                "title": "36470",
                "pk_id": "36470"
            },
            {
                "id": 34170,
                "title": "34170",
                "pk_id": "34170"
            },
            {
                "id": 45790,
                "title": "45790",
                "pk_id": "45790"
            },
            {
                "id": 48630,
                "title": "48630",
                "pk_id": "48630"
            },
            {
                "id": 38310,
                "title": "38310",
                "pk_id": "38310"
            },
            {
                "id": 36480,
                "title": "36480",
                "pk_id": "36480"
            },
            {
                "id": 33720,
                "title": "33720",
                "pk_id": "33720"
            },
            {
                "id": 34290,
                "title": "34290",
                "pk_id": "34290"
            },
            {
                "id": 38376,
                "title": "38376",
                "pk_id": "38376"
            },
            {
                "id": 37350,
                "title": "37350",
                "pk_id": "37350"
            },
            {
                "id": 33260,
                "title": "33260",
                "pk_id": "33260"
            },
            {
                "id": 40570,
                "title": "40570",
                "pk_id": "40570"
            },
            {
                "id": 47660,
                "title": "47660",
                "pk_id": "47660"
            },
            {
                "id": 48480,
                "title": "48480",
                "pk_id": "48480"
            },
            {
                "id": 46800,
                "title": "46800",
                "pk_id": "46800"
            },
            {
                "id": 37440,
                "title": "37440",
                "pk_id": "37440"
            },
            {
                "id": 37980,
                "title": "37980",
                "pk_id": "37980"
            },
            {
                "id": 41780,
                "title": "41780",
                "pk_id": "41780"
            },
            {
                "id": 32330,
                "title": "32330",
                "pk_id": "32330"
            },
            {
                "id": 38363,
                "title": "38363",
                "pk_id": "38363"
            },
            {
                "id": 34220,
                "title": "34220",
                "pk_id": "34220"
            },
            {
                "id": 33190,
                "title": "33190",
                "pk_id": "33190"
            },
            {
                "id": 40840,
                "title": "40840",
                "pk_id": "40840"
            },
            {
                "id": 34470,
                "title": "34470",
                "pk_id": "34470"
            },
            {
                "id": 38000,
                "title": "38000",
                "pk_id": "38000"
            },
            {
                "id": 38010,
                "title": "38010",
                "pk_id": "38010"
            },
            {
                "id": 44850,
                "title": "44850",
                "pk_id": "44850"
            },
            {
                "id": 33000,
                "title": "33000",
                "pk_id": "33000"
            },
            {
                "id": 41680,
                "title": "41680",
                "pk_id": "41680"
            },
            {
                "id": 46790,
                "title": "46790",
                "pk_id": "46790"
            },
            {
                "id": 34560,
                "title": "34560",
                "pk_id": "34560"
            },
            {
                "id": 34270,
                "title": "34270",
                "pk_id": "34270"
            }
        ]
    },
    {
        "name": "Stdis",
        "masterkey": "stdis_id",
        "rows": [
            {
                "id": 32000,
                "title": "32000 - ДАРНИЦА",
                "pk_id": "32000"
            },
            {
                "id": 32010,
                "title": "32010 - КИЕВ-ДЕМЕЕВСКИЙ",
                "pk_id": "32010"
            },
            {
                "id": 32070,
                "title": "32070 - КИЕВ-ДНЕПРОВСКИЙ",
                "pk_id": "32070"
            },
            {
                "id": 32330,
                "title": "32330 - БРОВАРЫ",
                "pk_id": "32330"
            },
            {
                "id": 33000,
                "title": "33000 - ЖМЕРИНКА",
                "pk_id": "33000"
            },
            {
                "id": 33010,
                "title": "33010 - ВОЛОЧИСК",
                "pk_id": "33010"
            },
            {
                "id": 33040,
                "title": "33040 - ЧЕРНЫЙ ОСТРОВ",
                "pk_id": "33040"
            },
            {
                "id": 33060,
                "title": "33060 - ГРЕЧАНЫ",
                "pk_id": "33060"
            },
            {
                "id": 33070,
                "title": "33070 - ХМЕЛЬНИЦКИЙ",
                "pk_id": "33070"
            },
            {
                "id": 33080,
                "title": "33080 - БОГДАНОВЦЫ",
                "pk_id": "33080"
            },
            {
                "id": 33100,
                "title": "33100 - ДЕРАЖНЯ",
                "pk_id": "33100"
            },
            {
                "id": 33115,
                "title": "33115 - СЕРБИНОВЦЫ",
                "pk_id": "33115"
            },
            {
                "id": 33170,
                "title": "33170 - ЯРОШЕНКА",
                "pk_id": "33170"
            },
            {
                "id": 33190,
                "title": "33190 - МОГИЛЕВ-ПОДОЛЬСКИЙ",
                "pk_id": "33190"
            },
            {
                "id": 33260,
                "title": "33260 - БАР",
                "pk_id": "33260"
            },
            {
                "id": 33300,
                "title": "33300 - ГУМЕНЦЫ",
                "pk_id": "33300"
            },
            {
                "id": 33580,
                "title": "33580 - ВИННИЦА",
                "pk_id": "33580"
            },
            {
                "id": 33720,
                "title": "33720 - КОРДЫШЕВКА",
                "pk_id": "33720"
            },
            {
                "id": 34000,
                "title": "34000 - ШЕПЕТОВКА",
                "pk_id": "34000"
            },
            {
                "id": 34100,
                "title": "34100 - ОСТРОГ",
                "pk_id": "34100"
            },
            {
                "id": 34112,
                "title": "34112 - МОГИЛЯНЫ",
                "pk_id": "34112"
            },
            {
                "id": 34140,
                "title": "34140 - СЛАВУТА I",
                "pk_id": "34140"
            },
            {
                "id": 34160,
                "title": "34160 - ПОНИНКА",
                "pk_id": "34160"
            },
            {
                "id": 34170,
                "title": "34170 - ПОЛОННОЕ",
                "pk_id": "34170"
            },
            {
                "id": 34190,
                "title": "34190 - ПЕЧАНОВКА",
                "pk_id": "34190"
            },
            {
                "id": 34220,
                "title": "34220 - МИХАЙЛЕНКИ",
                "pk_id": "34220"
            },
            {
                "id": 34240,
                "title": "34240 - БЕРДИЧЕВ",
                "pk_id": "34240"
            },
            {
                "id": 34260,
                "title": "34260 - КАЗАТИН II",
                "pk_id": "34260"
            },
            {
                "id": 34270,
                "title": "34270 - КАЗАТИН I",
                "pk_id": "34270"
            },
            {
                "id": 34290,
                "title": "34290 - БРОВКИ",
                "pk_id": "34290"
            },
            {
                "id": 34370,
                "title": "34370 - УСТИНОВКА",
                "pk_id": "34370"
            },
            {
                "id": 34410,
                "title": "34410 - РАКИТНО",
                "pk_id": "34410"
            },
            {
                "id": 34440,
                "title": "34440 - МИРОНОВКА",
                "pk_id": "34440"
            },
            {
                "id": 34470,
                "title": "34470 - ТРИПОЛЬЕ-ДНЕПРОВСКОЕ",
                "pk_id": "34470"
            },
            {
                "id": 34560,
                "title": "34560 - ЖИТОМИР",
                "pk_id": "34560"
            },
            {
                "id": 34600,
                "title": "34600 - НОВАЯ БОРОВАЯ",
                "pk_id": "34600"
            },
            {
                "id": 34630,
                "title": "34630 - КОРОСТЕНЬ",
                "pk_id": "34630"
            },
            {
                "id": 34640,
                "title": "34640 - КОРОСТЕНЬ-ПОДОЛЬСКИЙ",
                "pk_id": "34640"
            },
            {
                "id": 34710,
                "title": "34710 - ШАТРИЩЕ",
                "pk_id": "34710"
            },
            {
                "id": 34807,
                "title": "34807 - РЫХАЛЬСКАЯ",
                "pk_id": "34807"
            },
            {
                "id": 35000,
                "title": "35000 - ЗДОЛБУНОВ",
                "pk_id": "35000"
            },
            {
                "id": 35080,
                "title": "35080 - РАДИВИЛОВ",
                "pk_id": "35080"
            },
            {
                "id": 35090,
                "title": "35090 - БРОДЫ",
                "pk_id": "35090"
            },
            {
                "id": 35250,
                "title": "35250 - ИЗОВ",
                "pk_id": "35250"
            },
            {
                "id": 35321,
                "title": "35321 - ОВАДНО",
                "pk_id": "35321"
            },
            {
                "id": 35400,
                "title": "35400 - КОВЕЛЬ",
                "pk_id": "35400"
            },
            {
                "id": 35490,
                "title": "35490 - МАНЕВИЧИ",
                "pk_id": "35490"
            },
            {
                "id": 35550,
                "title": "35550 - САРНЫ",
                "pk_id": "35550"
            },
            {
                "id": 35660,
                "title": "35660 - РОВНО",
                "pk_id": "35660"
            },
            {
                "id": 35780,
                "title": "35780 - ЛУЦК",
                "pk_id": "35780"
            },
            {
                "id": 35850,
                "title": "35850 - ГОЛОБЫ",
                "pk_id": "35850"
            },
            {
                "id": 35880,
                "title": "35880 - РОЖИЩЕ",
                "pk_id": "35880"
            },
            {
                "id": 35900,
                "title": "35900 - КИВЕРЦЫ",
                "pk_id": "35900"
            },
            {
                "id": 35940,
                "title": "35940 - ОБАРОВ",
                "pk_id": "35940"
            },
            {
                "id": 36000,
                "title": "36000 - ТЕРНОПОЛЬ",
                "pk_id": "36000"
            },
            {
                "id": 36050,
                "title": "36050 - ЗЛОЧЕВ",
                "pk_id": "36050"
            },
            {
                "id": 36090,
                "title": "36090 - БОРКИ-ВЕЛИКИЕ",
                "pk_id": "36090"
            },
            {
                "id": 36330,
                "title": "36330 - КОПЫЧИНЦЫ",
                "pk_id": "36330"
            },
            {
                "id": 36360,
                "title": "36360 - ГАДЫНКИВЦИ",
                "pk_id": "36360"
            },
            {
                "id": 36440,
                "title": "36440 - БУЧАЧ",
                "pk_id": "36440"
            },
            {
                "id": 36470,
                "title": "36470 - ЧЕРТКОВ",
                "pk_id": "36470"
            },
            {
                "id": 36480,
                "title": "36480 - БЕЛАЯ-ЧЕРТКОВСКАЯ",
                "pk_id": "36480"
            },
            {
                "id": 36660,
                "title": "36660 - ЧЕРНОВЦЫ",
                "pk_id": "36660"
            },
            {
                "id": 37000,
                "title": "37000 - ЛЬВОВ",
                "pk_id": "37000"
            },
            {
                "id": 37021,
                "title": "37021 - ПОДБОРЦЫ",
                "pk_id": "37021"
            },
            {
                "id": 37040,
                "title": "37040 - КЛЕПАРОВ",
                "pk_id": "37040"
            },
            {
                "id": 37060,
                "title": "37060 - ДУБЛЯНЫ-ЛЬВОВСКИЕ",
                "pk_id": "37060"
            },
            {
                "id": 37350,
                "title": "37350 - МОСТИСКА II",
                "pk_id": "37350"
            },
            {
                "id": 37440,
                "title": "37440 - СУДОВАЯ ВИШНЯ",
                "pk_id": "37440"
            },
            {
                "id": 37520,
                "title": "37520 - ТУРКА",
                "pk_id": "37520"
            },
            {
                "id": 37523,
                "title": "37523 - СОКОЛИКИ",
                "pk_id": "37523"
            },
            {
                "id": 37570,
                "title": "37570 - САМБОР",
                "pk_id": "37570"
            },
            {
                "id": 37580,
                "title": "37580 - РУДКИ",
                "pk_id": "37580"
            },
            {
                "id": 37670,
                "title": "37670 - ТУХЛЯ",
                "pk_id": "37670"
            },
            {
                "id": 37690,
                "title": "37690 - СКОЛЕ",
                "pk_id": "37690"
            },
            {
                "id": 37709,
                "title": "37709 - ЛЮБЕНЦЫ",
                "pk_id": "37709"
            },
            {
                "id": 37740,
                "title": "37740 - СТРЫЙ",
                "pk_id": "37740"
            },
            {
                "id": 37780,
                "title": "37780 - НИКОЛАЕВ-ДНЕСТРОВСКИЙ",
                "pk_id": "37780"
            },
            {
                "id": 37790,
                "title": "37790 - ЩИРЕЦ II",
                "pk_id": "37790"
            },
            {
                "id": 37860,
                "title": "37860 - ПЕРСЕНКОВКА",
                "pk_id": "37860"
            },
            {
                "id": 37980,
                "title": "37980 - КРАСНЕ",
                "pk_id": "37980"
            },
            {
                "id": 38000,
                "title": "38000 - МУКАЧЕВО",
                "pk_id": "38000"
            },
            {
                "id": 38010,
                "title": "38010 - ЧОП",
                "pk_id": "38010"
            },
            {
                "id": 38030,
                "title": "38030 - ЧОП (ЭКСП. ЖСР)",
                "pk_id": "38030"
            },
            {
                "id": 38100,
                "title": "38100 - УЖГОРОД",
                "pk_id": "38100"
            },
            {
                "id": 38170,
                "title": "38170 - ДУБРЫНИЧИ",
                "pk_id": "38170"
            },
            {
                "id": 38220,
                "title": "38220 - СЯНКИ",
                "pk_id": "38220"
            },
            {
                "id": 38240,
                "title": "38240 - ЕСЕНЬ",
                "pk_id": "38240"
            },
            {
                "id": 38250,
                "title": "38250 - БАТЕВО",
                "pk_id": "38250"
            },
            {
                "id": 38310,
                "title": "38310 - СТРАБИЧЕВО",
                "pk_id": "38310"
            },
            {
                "id": 38360,
                "title": "38360 - СВАЛЯВА",
                "pk_id": "38360"
            },
            {
                "id": 38363,
                "title": "38363 - ВОВЧИЙ",
                "pk_id": "38363"
            },
            {
                "id": 38370,
                "title": "38370 - ВОЛОВЕЦ",
                "pk_id": "38370"
            },
            {
                "id": 38376,
                "title": "38376 - ЛАВОЧНЕ",
                "pk_id": "38376"
            },
            {
                "id": 38440,
                "title": "38440 - ВИНОГРАДОВО-ЗАКАРПАТСКОЕ",
                "pk_id": "38440"
            },
            {
                "id": 38470,
                "title": "38470 - КОРОЛЕВО",
                "pk_id": "38470"
            },
            {
                "id": 38530,
                "title": "38530 - ХУСТ",
                "pk_id": "38530"
            },
            {
                "id": 38850,
                "title": "38850 - ХРЫПЛИН",
                "pk_id": "38850"
            },
            {
                "id": 40000,
                "title": "40000 - ОДЕССА-СОРТИРОВОЧНАЯ",
                "pk_id": "40000"
            },
            {
                "id": 40020,
                "title": "40020 - ОДЕССА-ТОВАРНАЯ",
                "pk_id": "40020"
            },
            {
                "id": 40080,
                "title": "40080 - ОДЕССА-ПЕРЕСЫПЬ",
                "pk_id": "40080"
            },
            {
                "id": 40110,
                "title": "40110 - ЧЕРНОМОРСКАЯ",
                "pk_id": "40110"
            },
            {
                "id": 40170,
                "title": "40170 - ОДЕССА-ЗАПАДНАЯ",
                "pk_id": "40170"
            },
            {
                "id": 40195,
                "title": "40195 - КАРОЛИНО-БУГАЗ",
                "pk_id": "40195"
            },
            {
                "id": 40320,
                "title": "40320 - БЕЛГОРОД-ДНЕСТРОВСКИЙ",
                "pk_id": "40320"
            },
            {
                "id": 40390,
                "title": "40390 - АРЦЫЗ",
                "pk_id": "40390"
            },
            {
                "id": 40450,
                "title": "40450 - ИЗМАИЛ",
                "pk_id": "40450"
            },
            {
                "id": 40510,
                "title": "40510 - ОДЕССА-ЗАСТАВА I",
                "pk_id": "40510"
            },
            {
                "id": 40530,
                "title": "40530 - ДАЧНАЯ",
                "pk_id": "40530"
            },
            {
                "id": 40540,
                "title": "40540 - ВЫГОДА",
                "pk_id": "40540"
            },
            {
                "id": 40570,
                "title": "40570 - РАЗДЕЛЬНАЯ-СОРТИРОВОЧНАЯ",
                "pk_id": "40570"
            },
            {
                "id": 40580,
                "title": "40580 - КУЧУРГАН",
                "pk_id": "40580"
            },
            {
                "id": 40595,
                "title": "40595 - МИГАЕВО",
                "pk_id": "40595"
            },
            {
                "id": 40660,
                "title": "40660 - КСЕНИЕВО",
                "pk_id": "40660"
            },
            {
                "id": 40680,
                "title": "40680 - ПОДОЛЬСК",
                "pk_id": "40680"
            },
            {
                "id": 40720,
                "title": "40720 - ЛЮБАШЕВКА",
                "pk_id": "40720"
            },
            {
                "id": 40750,
                "title": "40750 - КОНЕЦПОЛЬ",
                "pk_id": "40750"
            },
            {
                "id": 40760,
                "title": "40760 - ПЕРВОМАЙСК-НА-БУГЕ",
                "pk_id": "40760"
            },
            {
                "id": 40790,
                "title": "40790 - СЛОБОДКА",
                "pk_id": "40790"
            },
            {
                "id": 40810,
                "title": "40810 - КОДЫМА",
                "pk_id": "40810"
            },
            {
                "id": 40820,
                "title": "40820 - ПОПЕЛЮХИ",
                "pk_id": "40820"
            },
            {
                "id": 40840,
                "title": "40840 - КРЫЖОПОЛЬ",
                "pk_id": "40840"
            },
            {
                "id": 40850,
                "title": "40850 - ВАПНЯРКА",
                "pk_id": "40850"
            },
            {
                "id": 41000,
                "title": "41000 - ЗНАМЕНКА",
                "pk_id": "41000"
            },
            {
                "id": 41030,
                "title": "41030 - КОРИСТОВКА",
                "pk_id": "41030"
            },
            {
                "id": 41060,
                "title": "41060 - СЧАСТЛИВАЯ",
                "pk_id": "41060"
            },
            {
                "id": 41074,
                "title": "41074 - ЛЕКАРЕВКА",
                "pk_id": "41074"
            },
            {
                "id": 41110,
                "title": "41110 - ЧЕРНОЛЕССКАЯ",
                "pk_id": "41110"
            },
            {
                "id": 41130,
                "title": "41130 - КАНАТОВО",
                "pk_id": "41130"
            },
            {
                "id": 41140,
                "title": "41140 - КРОПИВНИЦКИЙ",
                "pk_id": "41140"
            },
            {
                "id": 41190,
                "title": "41190 - ПОМОШНАЯ",
                "pk_id": "41190"
            },
            {
                "id": 41193,
                "title": "41193 - БЕШКЕТОВО (РЗД)",
                "pk_id": "41193"
            },
            {
                "id": 41250,
                "title": "41250 - НИКЕЛЬ-ПОБУЖСКИЙ",
                "pk_id": "41250"
            },
            {
                "id": 41351,
                "title": "41351 - ОЛЕЙНИКОВО",
                "pk_id": "41351"
            },
            {
                "id": 41410,
                "title": "41410 - ДОЛИНСКАЯ",
                "pk_id": "41410"
            },
            {
                "id": 41422,
                "title": "41422 - ОСИКОВАТА",
                "pk_id": "41422"
            },
            {
                "id": 41424,
                "title": "41424 - КРОПИВНИЦКАЯ",
                "pk_id": "41424"
            },
            {
                "id": 41520,
                "title": "41520 - НИКОЛАЕВ-ГРУЗОВОЙ",
                "pk_id": "41520"
            },
            {
                "id": 41680,
                "title": "41680 - КАХОВКА",
                "pk_id": "41680"
            },
            {
                "id": 41750,
                "title": "41750 - ЖОВТНЕВАЯ",
                "pk_id": "41750"
            },
            {
                "id": 41780,
                "title": "41780 - ХЕРСОН",
                "pk_id": "41780"
            },
            {
                "id": 42000,
                "title": "42000 - ИМ. ТАРАСА ШЕВЧЕНКО",
                "pk_id": "42000"
            },
            {
                "id": 42005,
                "title": "42005 - РАЙГОРОД",
                "pk_id": "42005"
            },
            {
                "id": 42240,
                "title": "42240 - ГОРОДИЩЕ",
                "pk_id": "42240"
            },
            {
                "id": 42260,
                "title": "42260 - ЦВЕТКОВО",
                "pk_id": "42260"
            },
            {
                "id": 42310,
                "title": "42310 - ФУНДУКЛЕЕВКА",
                "pk_id": "42310"
            },
            {
                "id": 42410,
                "title": "42410 - БЕЛОЗЕРЬЕ",
                "pk_id": "42410"
            },
            {
                "id": 43000,
                "title": "43000 - КУПЯНСК-СОРТИРОВОЧНЫЙ",
                "pk_id": "43000"
            },
            {
                "id": 44020,
                "title": "44020 - ОСНОВА",
                "pk_id": "44020"
            },
            {
                "id": 44850,
                "title": "44850 - ПОЛТАВА-КИЕВСКАЯ",
                "pk_id": "44850"
            },
            {
                "id": 45000,
                "title": "45000 - НИЖНЕДНЕПРОВСК-УЗЕЛ",
                "pk_id": "45000"
            },
            {
                "id": 45002,
                "title": "45002 - ДНЕПР-ЛОЦМАНСКАЯ",
                "pk_id": "45002"
            },
            {
                "id": 45110,
                "title": "45110 - ДНЕПР-ГЛАВНЫЙ",
                "pk_id": "45110"
            },
            {
                "id": 45170,
                "title": "45170 - ПРАВДА",
                "pk_id": "45170"
            },
            {
                "id": 45200,
                "title": "45200 - НОВОМОСКОВСК-ДНЕПРОВСКИЙ",
                "pk_id": "45200"
            },
            {
                "id": 45360,
                "title": "45360 - СИНЕЛЬНИКОВО I",
                "pk_id": "45360"
            },
            {
                "id": 45590,
                "title": "45590 - ТРИТУЗНАЯ",
                "pk_id": "45590"
            },
            {
                "id": 45600,
                "title": "45600 - ЗАПОРОЖЬЕ-КАМЕНСКОЕ",
                "pk_id": "45600"
            },
            {
                "id": 45610,
                "title": "45610 - ВОСКОБОЙНЯ",
                "pk_id": "45610"
            },
            {
                "id": 45640,
                "title": "45640 - ВЕРХОВЦЕВО",
                "pk_id": "45640"
            },
            {
                "id": 45680,
                "title": "45680 - ПЯТИХАТКИ",
                "pk_id": "45680"
            },
            {
                "id": 45682,
                "title": "45682 - ПЯТИХАТКИ-СТЫКОВАЯ",
                "pk_id": "45682"
            },
            {
                "id": 45700,
                "title": "45700 - ЖЕЛТЫЕ ВОДЫ II",
                "pk_id": "45700"
            },
            {
                "id": 45702,
                "title": "45702 - ЖЕЛТЫЕ ВОДЫ I",
                "pk_id": "45702"
            },
            {
                "id": 45710,
                "title": "45710 - САВРО",
                "pk_id": "45710"
            },
            {
                "id": 45730,
                "title": "45730 - ТЕРНЫ",
                "pk_id": "45730"
            },
            {
                "id": 45740,
                "title": "45740 - ГРЕКОВАТАЯ",
                "pk_id": "45740"
            },
            {
                "id": 45750,
                "title": "45750 - КРАСНЫЙ ШАХТЕР",
                "pk_id": "45750"
            },
            {
                "id": 45790,
                "title": "45790 - РОКОВАТАЯ",
                "pk_id": "45790"
            },
            {
                "id": 46000,
                "title": "46000 - ЗАПОРОЖЬЕ-ЛЕВОЕ",
                "pk_id": "46000"
            },
            {
                "id": 46070,
                "title": "46070 - ЗАПОРОЖЬЕ I",
                "pk_id": "46070"
            },
            {
                "id": 46190,
                "title": "46190 - ТАВРИЧЕСК",
                "pk_id": "46190"
            },
            {
                "id": 46240,
                "title": "46240 - КАМЫШ-ЗАРЯ",
                "pk_id": "46240"
            },
            {
                "id": 46270,
                "title": "46270 - СИНЯЯ ГОРА",
                "pk_id": "46270"
            },
            {
                "id": 46300,
                "title": "46300 - ПОЛОГИ",
                "pk_id": "46300"
            },
            {
                "id": 46350,
                "title": "46350 - ПЕРЕДАТОЧНАЯ",
                "pk_id": "46350"
            },
            {
                "id": 46520,
                "title": "46520 - ДНЕПРОСТРОЙ II",
                "pk_id": "46520"
            },
            {
                "id": 46600,
                "title": "46600 - НИКОПОЛЬ",
                "pk_id": "46600"
            },
            {
                "id": 46620,
                "title": "46620 - ЧЕРТОМЛЫК",
                "pk_id": "46620"
            },
            {
                "id": 46660,
                "title": "46660 - АПОСТОЛОВО",
                "pk_id": "46660"
            },
            {
                "id": 46692,
                "title": "46692 - НОВОБЛОЧНАЯ",
                "pk_id": "46692"
            },
            {
                "id": 46700,
                "title": "46700 - КРИВОЙ РОГ-ГЛАВНЫЙ",
                "pk_id": "46700"
            },
            {
                "id": 46710,
                "title": "46710 - КРИВОЙ РОГ-СОРТИРОВОЧНЫЙ",
                "pk_id": "46710"
            },
            {
                "id": 46720,
                "title": "46720 - КРИВОЙ РОГ",
                "pk_id": "46720"
            },
            {
                "id": 46730,
                "title": "46730 - КРИВОЙ РОГ-ЗАПАДНЫЙ",
                "pk_id": "46730"
            },
            {
                "id": 46760,
                "title": "46760 - МОИСЕЕВКА",
                "pk_id": "46760"
            },
            {
                "id": 46790,
                "title": "46790 - ГЕЙКОВКА",
                "pk_id": "46790"
            },
            {
                "id": 46800,
                "title": "46800 - ВИСУНЬ",
                "pk_id": "46800"
            },
            {
                "id": 47600,
                "title": "47600 - МЕЛИТОПОЛЬ",
                "pk_id": "47600"
            },
            {
                "id": 47630,
                "title": "47630 - ФЕДОРОВКА",
                "pk_id": "47630"
            },
            {
                "id": 47660,
                "title": "47660 - ДНЕПРОРУДНАЯ",
                "pk_id": "47660"
            },
            {
                "id": 47680,
                "title": "47680 - КАХОВСКОЕ МОРЕ",
                "pk_id": "47680"
            },
            {
                "id": 48190,
                "title": "48190 - УДАЧНАЯ",
                "pk_id": "48190"
            },
            {
                "id": 48200,
                "title": "48200 - ПОКРОВСК",
                "pk_id": "48200"
            },
            {
                "id": 48230,
                "title": "48230 - РОССИЯ",
                "pk_id": "48230"
            },
            {
                "id": 48280,
                "title": "48280 - АВДЕЕВКА",
                "pk_id": "48280"
            },
            {
                "id": 48460,
                "title": "48460 - МАРИУПОЛЬ-ПОРТ",
                "pk_id": "48460"
            },
            {
                "id": 48480,
                "title": "48480 - САРТАНА",
                "pk_id": "48480"
            },
            {
                "id": 48500,
                "title": "48500 - АСЛАНОВО",
                "pk_id": "48500"
            },
            {
                "id": 48560,
                "title": "48560 - МАРИУПОЛЬ-СОРТИРОВОЧНЫЙ",
                "pk_id": "48560"
            },
            {
                "id": 48590,
                "title": "48590 - КАРАНЬ",
                "pk_id": "48590"
            },
            {
                "id": 48620,
                "title": "48620 - ВОЛНОВАХА",
                "pk_id": "48620"
            },
            {
                "id": 48630,
                "title": "48630 - ВЕЛИКО-АНАДОЛЬ",
                "pk_id": "48630"
            },
            {
                "id": 49090,
                "title": "49090 - ФЕНОЛЬНАЯ",
                "pk_id": "49090"
            },
            {
                "id": 49290,
                "title": "49290 - РОДИНСКАЯ",
                "pk_id": "49290"
            },
            {
                "id": 49310,
                "title": "49310 - ДОБРОПОЛЬЕ",
                "pk_id": "49310"
            },
            {
                "id": 49600,
                "title": "49600 - ПОПАСНАЯ",
                "pk_id": "49600"
            },
            {
                "id": 49870,
                "title": "49870 - РУБЕЖНОЕ",
                "pk_id": "49870"
            }
        ]
    },
    {
        "name": "Nazvgruza",
        "masterkey": "id",
        "rows": [
            {
                "id": 300,
                "title": "КОНТЕЙНЕРЫ КРУПНОТОНАЖНЫЕ",
                "pk_id": "00300"
            },
            {
                "id": 14109,
                "title": "КОНЦЕНТРАТ ЖЕЛЕЗОРУДНЫЙ (ГЕМАТИТ)",
                "pk_id": "14109"
            },
            {
                "id": 14111,
                "title": "ОКАТЫШИ ЖЕЛЕЗОРУДНЫЕ",
                "pk_id": "14111"
            },
            {
                "id": 14113,
                "title": "РУДА ЖЕЛЕЗНАЯ АГЛОМЕРАЦИОННАЯ (АГЛОРУДА)",
                "pk_id": "14113"
            },
            {
                "id": 14114,
                "title": "РУДА ЖЕЛЕЗНАЯ ДОМЕННАЯ",
                "pk_id": "14114"
            },
            {
                "id": 14116,
                "title": "РУДА ЖЕЛЕЗНАЯ, НЕ ПОИМЕНОВАННАЯ В АЛФАВИТЕ",
                "pk_id": "14116"
            },
            {
                "id": 14118,
                "title": "РУДЫ ЧЕРНЫХ МЕТАЛЛОВ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "14118"
            },
            {
                "id": 15104,
                "title": "БРИКЕТЫ ТИТАНОМАГНЕТИТОВОЙ РУДЫ",
                "pk_id": "15104"
            },
            {
                "id": 16101,
                "title": "АНТРАЦИТ",
                "pk_id": "16101"
            },
            {
                "id": 16104,
                "title": "КОНЦЕНТРАТ УГОЛЬНЫЙ",
                "pk_id": "16104"
            },
            {
                "id": 16111,
                "title": "УГОЛЬ КАМЕННЫЙ МАРКИ Г-ГАЗОВЫЙ",
                "pk_id": "16111"
            },
            {
                "id": 16113,
                "title": "УГОЛЬ КАМЕННЫЙ МАРКИ Ж-ЖИРНЫЙ",
                "pk_id": "16113"
            },
            {
                "id": 16117,
                "title": "УГОЛЬ КАМЕННЫЙ МАРКИ СС-СЛАБОСПЕКАЮЩИЙСЯ",
                "pk_id": "16117"
            },
            {
                "id": 16120,
                "title": "УГОЛЬ КАМЕННЫЙ, НЕ ПОИМЕНОВАННЫЙ В АЛФАВИТЕ",
                "pk_id": "16120"
            },
            {
                "id": 17103,
                "title": "КОКС ДОМЕННЫЙ",
                "pk_id": "17103"
            },
            {
                "id": 17108,
                "title": "КОКС, НЕ ПОИМЕНОВАННЫЙ В АЛФАВИТЕ",
                "pk_id": "17108"
            },
            {
                "id": 17110,
                "title": "МЕЛОЧЬ КОКСОВАЯ",
                "pk_id": "17110"
            },
            {
                "id": 17111,
                "title": "ОРЕШЕК КОКСОВЫЙ",
                "pk_id": "17111"
            },
            {
                "id": 21403,
                "title": "ТОПЛИВО ДИЗЕЛЬНОЕ С ТЕМПЕРАТУРОЙ ВСПЫШКИ ВЫШЕ 61С (В ЗАКРЫТОМ ТИГЛЕ)",
                "pk_id": "21403"
            },
            {
                "id": 23107,
                "title": "ПЕСОК СТРОИТЕЛЬНЫЙ",
                "pk_id": "23107"
            },
            {
                "id": 23243,
                "title": "ЩЕБЕНЬ, НЕ ПОИМЕНОВАННЫЙ В АЛФАВИТЕ",
                "pk_id": "23243"
            },
            {
                "id": 23311,
                "title": "ИЗВЕСТЬ НЕГАШЕНАЯ",
                "pk_id": "23311"
            },
            {
                "id": 23507,
                "title": "ШЛАКИ ДОМЕННЫЕ",
                "pk_id": "23507"
            },
            {
                "id": 24112,
                "title": "БОЙ КИРПИЧА ШАМОТНОГО",
                "pk_id": "24112"
            },
            {
                "id": 24122,
                "title": "ГЛИНА БЕНТОНИТОВАЯ",
                "pk_id": "24122"
            },
            {
                "id": 27100,
                "title": "ШЛАКИ ГРАНУЛИРОВАННЫЕ",
                "pk_id": "27100"
            },
            {
                "id": 29102,
                "title": "ДОЛОМИТ СЫРОЙ МЕТАЛЛУРГИЧЕСКИЙ",
                "pk_id": "29102"
            },
            {
                "id": 29103,
                "title": "ИЗВЕСТНЯК ДЛЯ ФЛЮСОВАНИЯ",
                "pk_id": "29103"
            },
            {
                "id": 29105,
                "title": "ФЛЮСЫ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "29105"
            },
            {
                "id": 29202,
                "title": "ИЗВЕСТЬ ДЛЯ ФЛЮСОВАНИЯ",
                "pk_id": "29202"
            },
            {
                "id": 30105,
                "title": "КВАРЦИТЫ, КРОМЕ БАКАЛЬСКИХ, КРИВОРОЖСКИХ И КМА",
                "pk_id": "30105"
            },
            {
                "id": 30203,
                "title": "КИРПИЧ КИСЛОТОУПОРНЫЙ И ОГНЕУПОРНЫЙ (БОКСИТОВЫЙ, МАГНЕЗИТОВЫЙ, СИФОННЫЙ, ТАЛЬКОВЫЙ, ФАСОННЫЙ, ХРОМОМАГНЕЗИТОВЫ",
                "pk_id": "30203"
            },
            {
                "id": 30306,
                "title": "ИЗДЕЛИЯ КИСЛОТОУПОРНЫЕ И ОГНЕУПОРНЫЕ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "30306"
            },
            {
                "id": 30324,
                "title": "ПОРОШОК МАГНЕЗИТОВЫЙ МЕТАЛЛУРГИЧЕСКИЙ",
                "pk_id": "30324"
            },
            {
                "id": 31104,
                "title": "ЧУГУН ПЕРЕДЕЛЬНЫЙ ВЫСОКОКАЧЕСТВЕННЫЙ",
                "pk_id": "31104"
            },
            {
                "id": 31106,
                "title": "ЧУГУН ПЕРЕДЕЛЬНЫЙ РЯДОВОЙ",
                "pk_id": "31106"
            },
            {
                "id": 31305,
                "title": "ФЕРРОСИЛИКОМАРГАНЕЦ",
                "pk_id": "31305"
            },
            {
                "id": 31308,
                "title": "ФЕРРОСПЛАВЫ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "31308"
            },
            {
                "id": 31405,
                "title": "ЗАГОТОВКА СТАЛЬНАЯ, НЕ ПОИМЕНОВАННАЯ В АЛФАВИТЕ",
                "pk_id": "31405"
            },
            {
                "id": 31407,
                "title": "СЛЯБЫ (ЗАГОТОВКИ СТАЛЬНЫЕ)",
                "pk_id": "31407"
            },
            {
                "id": 31603,
                "title": "ЛОМ И ОТХОДЫ СТАЛЬНЫЕ НЕГАБАРИТНЫЕ",
                "pk_id": "31603"
            },
            {
                "id": 31605,
                "title": "ЛОМ СТАЛЬНОЙ СБОРНЫЙ",
                "pk_id": "31605"
            },
            {
                "id": 31607,
                "title": "ЛОМ ЧЕРНЫХ МЕТАЛЛОВ, НЕ ПОИМЕНОВАННЫЙ В АЛФАВИТЕ",
                "pk_id": "31607"
            },
            {
                "id": 31609,
                "title": "ОКАЛИНА ЧЕРНЫХ МЕТАЛЛОВ",
                "pk_id": "31609"
            },
            {
                "id": 31610,
                "title": "ПАКЕТЫ ИЗ ЛЕГКОВЕСНЫХ СТАЛЬНЫХ ОТХОДОВ И ЛОМА",
                "pk_id": "31610"
            },
            {
                "id": 31612,
                "title": "РЕЛЬСЫ-ЛОМ",
                "pk_id": "31612"
            },
            {
                "id": 32102,
                "title": "РЕЛЬСЫ МЕТАЛЛИЧЕСКИЕ НОВЫЕ Р-65",
                "pk_id": "32102"
            },
            {
                "id": 32204,
                "title": "БАЛКИ И ШВЕЛЛЕРЫ N 20 И БОЛЕЕ",
                "pk_id": "32204"
            },
            {
                "id": 32208,
                "title": "ШВЕЛЛЕРЫ МЕТАЛЛИЧЕСКИЕ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "32208"
            },
            {
                "id": 32305,
                "title": "ТРУБЫ МЕТАЛЛИЧЕСКИЕ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "32305"
            },
            {
                "id": 32403,
                "title": "КАТАНКА СТАЛЬНАЯ",
                "pk_id": "32403"
            },
            {
                "id": 32406,
                "title": "ЛЕНТА СТАЛЬНАЯ ХОЛОДНОКАТАНАЯ",
                "pk_id": "32406"
            },
            {
                "id": 32411,
                "title": "ПРОКАТ ЧЕРНЫХ МЕТАЛЛОВ, НЕ ПОИМЕНОВАННЫЙ В АЛФАВИТЕ",
                "pk_id": "32411"
            },
            {
                "id": 32415,
                "title": "СТАЛЬ ЛИСТОВАЯ КРОВЕЛЬНАЯ, В ТОМ ЧИСЛЕ ОЦИНКОВАННАЯ",
                "pk_id": "32415"
            },
            {
                "id": 32416,
                "title": "СТАЛЬ ЛИСТОВАЯ, НЕ ПОИМЕНОВАННАЯ В АЛФАВИТЕ",
                "pk_id": "32416"
            },
            {
                "id": 32418,
                "title": "СТАЛЬ СОРТОВАЯ",
                "pk_id": "32418"
            },
            {
                "id": 32419,
                "title": "СТАЛЬ ТОНКОЛИСТОВАЯ",
                "pk_id": "32419"
            },
            {
                "id": 32420,
                "title": "СТОЙКИ РУДНИЧНЫЕ МЕТАЛЛИЧЕСКИЕ",
                "pk_id": "32420"
            },
            {
                "id": 32421,
                "title": "ШАРЫ СТАЛЬНЫЕ ПОМОЛЬНЫЕ",
                "pk_id": "32421"
            },
            {
                "id": 39137,
                "title": "ТЕПЛОВОЗЫ, ПЕРЕВОЗИМЫЕ НЕ НА СВОИХ ОСЯХ",
                "pk_id": "39137"
            },
            {
                "id": 39149,
                "title": "КОНТЕЙНЕРЫ УНИВЕРСАЛЬНЫЕ ПОРОЖНИЕ СОБСТВЕННЫЕ (ПРИВАТНЫЕ)",
                "pk_id": "39149"
            },
            {
                "id": 41123,
                "title": "КАНАТЫ (ТРОСЫ) СТАЛЬНЫЕ",
                "pk_id": "41123"
            },
            {
                "id": 42116,
                "title": "ВАГОН ДЛЯ ПРОВОДНИКОВ",
                "pk_id": "42116"
            },
            {
                "id": 43302,
                "title": "АММОНИЯ СУЛЬФАТ (АММОНИЙ СЕРНОКИСЛЫЙ)",
                "pk_id": "43302"
            },
            {
                "id": 47105,
                "title": "ПЕК КАМЕННОУГОЛЬНЫЙ ЖИДКИЙ (РАСПЛАВЛЕННЫЙ)",
                "pk_id": "47105"
            },
            {
                "id": 47107,
                "title": "ПЕК КАМЕННОУГОЛЬНЫЙ ТВЕРДЫЙ",
                "pk_id": "47107"
            },
            {
                "id": 47114,
                "title": "СМОЛЫ КАМЕННОУГОЛЬНЫЕ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "47114"
            },
            {
                "id": 47531,
                "title": "",
                "pk_id": "47531"
            },
            {
                "id": 48123,
                "title": "КИСЛОТА СЕРНАЯ",
                "pk_id": "48123"
            },
            {
                "id": 48326,
                "title": "ЖЕЛЕЗА СУЛЬФАТ (ЖЕЛЕЗО СЕРНОКИСЛОЕ, КУПОРОС ЖЕЛЕЗНЫЙ)",
                "pk_id": "48326"
            },
            {
                "id": 48804,
                "title": "АММИАК ЖИДКИЙ БЕЗВОДНЫЙ",
                "pk_id": "48804"
            },
            {
                "id": 69308,
                "title": "ПРОЧИЕ ГРУЗЫ, НЕ ПОИМЕНОВАННЫЕ В АЛФАВИТЕ",
                "pk_id": "69308"
            },
            {
                "id": 69316,
                "title": "ОБОРУДОВАНИЕ НЕСЪЕМНОЕ, УСТАНОВЛЕННОЕ НА ВАГОНЕ (ТУРНИКЕТЫ, СТОЙКИ, КАССЕТЫ, ПРИЗМЫ И ДР.)",
                "pk_id": "69316"
            },
            {
                "id": 69317,
                "title": "ОБОРУДОВАНИЕ СЪЕМНОЕ (ТУРНИКЕТЫ, СТОЙКИ, КАССЕТЫ, ПРИЗМЫ, ХЛЕБНЫЕ ЩИТЫ, СТЯЖКИ, СТРОПЫ И ДР.)",
                "pk_id": "69317"
            },
            {
                "id": 71131,
                "title": "НАФТАЛИН",
                "pk_id": "71131"
            }
        ]
    },
    {
        "name": "Nazvpol",
        "masterkey": "id",
        "rows": [
            {
                "id": 51,
                "title": "ТОВ \"ЕКОІМПЕКС ІНВЕСТ",
                "pk_id": "0051"
            },
            {
                "id": 52,
                "title": "ТОВ \"Промтехтранс-М\"",
                "pk_id": "0052"
            },
            {
                "id": 53,
                "title": "ТОВ \"АКВАІЗОЛ\"",
                "pk_id": "0053"
            },
            {
                "id": 102,
                "title": "ПФ \"Ауріка\"",
                "pk_id": "0102"
            },
            {
                "id": 166,
                "title": "ТОВ \"ФАРЛІС\"",
                "pk_id": "0166"
            },
            {
                "id": 203,
                "title": "ПрАТ \"АВТОКРАЗ\"",
                "pk_id": "0203"
            },
            {
                "id": 251,
                "title": "ІП \"Євроголд індестріз  ЛТД\"",
                "pk_id": "0251"
            },
            {
                "id": 386,
                "title": "ТОВ \"АВ метал груп\"",
                "pk_id": "0386"
            },
            {
                "id": 389,
                "title": "ТОВ \"ТАРА\"",
                "pk_id": "0389"
            },
            {
                "id": 607,
                "title": "\"Тегра Україна ЛТД\"",
                "pk_id": "0607"
            },
            {
                "id": 700,
                "title": "ТОВ \"УСП\"",
                "pk_id": "0700"
            },
            {
                "id": 730,
                "title": "ТОВ \" ОПТОВИК-ПРОМ\"",
                "pk_id": "0730"
            },
            {
                "id": 744,
                "title": "ПрАТ \"Омелянівський гранітний кар'єр\"",
                "pk_id": "0744"
            },
            {
                "id": 1000,
                "title": "ТзОВ  \"ЛБК\"",
                "pk_id": "1000"
            },
            {
                "id": 1011,
                "title": "ТОВ \"МЕРИДІАН 34\"",
                "pk_id": "1011"
            },
            {
                "id": 1021,
                "title": "ТзОВ \"Чумак ЛТД\"",
                "pk_id": "1021"
            },
            {
                "id": 1052,
                "title": "ТОВ \"ЕНЕРГО ТРЕЙД ІНВЕСТ\"",
                "pk_id": "1052"
            },
            {
                "id": 1071,
                "title": "ТОВ \"МЕТАЛ ХОЛДІНГ ТРЕЙД\"",
                "pk_id": "1071"
            },
            {
                "id": 1082,
                "title": "ТОВ \"АГРОЛУК\"",
                "pk_id": "1082"
            },
            {
                "id": 1091,
                "title": "ФОП ВАСИЛЬЧИШИН ГАЛИНА ПАВЛІВНА",
                "pk_id": "1091"
            },
            {
                "id": 1102,
                "title": "ПП \"ТІМІРТАН\"",
                "pk_id": "1102"
            },
            {
                "id": 1111,
                "title": "ФОП \"Степченков Ярослав Євгенович\"",
                "pk_id": "1111"
            },
            {
                "id": 1231,
                "title": "ТОВ \"ПЗЗБВ\"",
                "pk_id": "1231"
            },
            {
                "id": 1407,
                "title": "ТОВ \"МЕТАЛОПРОМ-ПІВДЕНЬ\"",
                "pk_id": "1407"
            },
            {
                "id": 1451,
                "title": "В/Ч А1451",
                "pk_id": "1451"
            },
            {
                "id": 1462,
                "title": "ТОВ \"ТВК КРАЙТ\"",
                "pk_id": "1462"
            },
            {
                "id": 1548,
                "title": "ТОВ \"ОПТІМУМ ТРАНС\"",
                "pk_id": "1548"
            },
            {
                "id": 1648,
                "title": "ПАТ \"БАРВА\"",
                "pk_id": "1648"
            },
            {
                "id": 1653,
                "title": "ТОВ \"НВО \"СЗГТВ\"",
                "pk_id": "1653"
            },
            {
                "id": 1918,
                "title": "ТОВ \"ТЕТІС ТРАНС\"",
                "pk_id": "1918"
            },
            {
                "id": 1971,
                "title": "ТОВ \"БК \"СТАНДАРТ\"",
                "pk_id": "1971"
            },
            {
                "id": 2092,
                "title": "ФО-П Поздняков В. В.",
                "pk_id": "2092"
            },
            {
                "id": 2312,
                "title": "ТОВ \"Фортуна\"",
                "pk_id": "2312"
            },
            {
                "id": 2354,
                "title": "ФОП Пантелей Л.І.",
                "pk_id": "2354"
            },
            {
                "id": 2501,
                "title": "ТОВ \"ЮНІСТІЛ\"",
                "pk_id": "2501"
            },
            {
                "id": 2528,
                "title": "ТОВ   \"МЕТІНВЕСТ-СМЦ\" ДНІПРОВСЬКА ФІЛІЯ",
                "pk_id": "2528"
            },
            {
                "id": 2566,
                "title": "ТОВ \"УСК ЛТД\"",
                "pk_id": "2566"
            },
            {
                "id": 2811,
                "title": "СП ТОВ \"МОДЕРН-ЕКСПО\"",
                "pk_id": "2811"
            },
            {
                "id": 2892,
                "title": "ТОВ \"ДМЗ \"КАРПАТИ\"",
                "pk_id": "2892"
            },
            {
                "id": 2902,
                "title": "СВК \"ДРУЖБА НАРОДІВ\"",
                "pk_id": "2902"
            },
            {
                "id": 2911,
                "title": "ПрАТ «Дніпровагонмаш»",
                "pk_id": "2911"
            },
            {
                "id": 2937,
                "title": "ТОВ \"РОЛЛФОРМ\"",
                "pk_id": "2937"
            },
            {
                "id": 3128,
                "title": "ПАТ \"ДНIПРОВСЬКИЙ МЕТКОМБIНАТ\"",
                "pk_id": "3128"
            },
            {
                "id": 3128,
                "title": "ТОВ \"БІОЕНЕРГО\"",
                "pk_id": "3128"
            },
            {
                "id": 3134,
                "title": "ПРАТ \"ММК ІМ. ІЛЛІЧА\"",
                "pk_id": "3134"
            },
            {
                "id": 3154,
                "title": "Unikom Tranzit S.A.",
                "pk_id": "3154"
            },
            {
                "id": 3168,
                "title": "ПРАТ \" КАМЕТ-СТАЛЬ\"",
                "pk_id": "3168"
            },
            {
                "id": 3168,
                "title": "ПРАТ \"МК \"АЗОВСТАЛЬ\"",
                "pk_id": "3168"
            },
            {
                "id": 3209,
                "title": "АТ \"ЗФЗ\"",
                "pk_id": "3209"
            },
            {
                "id": 3236,
                "title": "ПРАТ \"ЮЖКОКС\"",
                "pk_id": "3236"
            },
            {
                "id": 3239,
                "title": "ПрАТ \"Дікергофф Цемент Україна\"",
                "pk_id": "3239"
            },
            {
                "id": 3370,
                "title": "ТОВ \"МЕТІНВЕСТ-СМЦ\"",
                "pk_id": "3370"
            },
            {
                "id": 3372,
                "title": "Філія ТОВ \"МЕТІНВЕСТ-СМЦ\" у м. Миколаїв",
                "pk_id": "3372"
            },
            {
                "id": 3465,
                "title": "ТОВ НВП \"СТАЛЬСЕРВІС\"",
                "pk_id": "3465"
            },
            {
                "id": 3470,
                "title": "ТОВ \"УКРПОЛІМЕТ\"",
                "pk_id": "3470"
            },
            {
                "id": 3512,
                "title": "ПРАТ \"ЗАПОРІЖВОГНЕТРИВ\"",
                "pk_id": "3512"
            },
            {
                "id": 3857,
                "title": "ПРАТ \"ЗАПОРІЖКОКС\"",
                "pk_id": "3857"
            },
            {
                "id": 3882,
                "title": "ТОВ \"ФІРМА \"ВІКАНТ\"",
                "pk_id": "3882"
            },
            {
                "id": 3925,
                "title": "ТОВ \"ПКПФ - Україна\"",
                "pk_id": "3925"
            },
            {
                "id": 4054,
                "title": "ТОВ \"ВАРТІС\"",
                "pk_id": "4054"
            },
            {
                "id": 4113,
                "title": "Філія \"Кам'янський елеватор\" ТОВ \"АДМ Знаменський елеватор\"",
                "pk_id": "4113"
            },
            {
                "id": 4264,
                "title": "ТОВ \"СЗ \"ОКЕАН\"",
                "pk_id": "4264"
            },
            {
                "id": 4284,
                "title": "ПРАТ\"Таганча\"",
                "pk_id": "4284"
            },
            {
                "id": 4286,
                "title": "ПП \"РАДИВИЛІВ-ВІКТАЛ\"",
                "pk_id": "4286"
            },
            {
                "id": 4384,
                "title": "ТОВ \"КАПРО ОЙЛ\"",
                "pk_id": "4384"
            },
            {
                "id": 4397,
                "title": "ТОВ \"Пагос\"",
                "pk_id": "4397"
            },
            {
                "id": 4400,
                "title": "ТОВ \"ДЕМЗ\"",
                "pk_id": "4400"
            },
            {
                "id": 4427,
                "title": "ТОВ \"Інвест Юнітрейд\"",
                "pk_id": "4427"
            },
            {
                "id": 4509,
                "title": "ТОВ \"Торговий Дім Хімтранс\"",
                "pk_id": "4509"
            },
            {
                "id": 4517,
                "title": "ТЗОВ \"НАУКОВО-ВИРОБНИЧЕ ПІДПРИЄМСТВО - РОЗЛІТ\"",
                "pk_id": "4517"
            },
            {
                "id": 4525,
                "title": "ТОВ \"ПРОМСИСТЕМИ ЛТД\"",
                "pk_id": "4525"
            },
            {
                "id": 4730,
                "title": "ПРАТ \" ШУ \" ПОКРОВСЬКЕ \"",
                "pk_id": "4730"
            },
            {
                "id": 4945,
                "title": "ПрАТ \"ЗЗРК\"",
                "pk_id": "4945"
            },
            {
                "id": 4945,
                "title": "Черкаська філія ПрАТ \"Київ-Дніпровське МППЗТ\"",
                "pk_id": "4945"
            },
            {
                "id": 5051,
                "title": "ПРАТ \"ХАРКІВСЬКИЙ  КОКСОВИЙ ЗАВОД\"",
                "pk_id": "5051"
            },
            {
                "id": 5066,
                "title": "ТОВ \"КУПЯНСКСПЕЦПЕРЕРОБКА\"",
                "pk_id": "5066"
            },
            {
                "id": 5068,
                "title": "ПАТ \"Запоріжсталь\"",
                "pk_id": "5068"
            },
            {
                "id": 5311,
                "title": "ПрАТ \"КАСКАД\"",
                "pk_id": "5311"
            },
            {
                "id": 5317,
                "title": "ТОВ \"Градієнт\"",
                "pk_id": "5317"
            },
            {
                "id": 5346,
                "title": "ПРАТ \"ЦЕНТРАЛЬНИЙ ГЗК\"",
                "pk_id": "5346"
            },
            {
                "id": 5504,
                "title": "ФІЛІЯ ТОВ \"МЕТІНВЕСТ-СМЦ\" ЗАХІДНА УКРАЇНА",
                "pk_id": "5504"
            },
            {
                "id": 5555,
                "title": "ТОВ \"Модуль - Україна\"",
                "pk_id": "5555"
            },
            {
                "id": 5672,
                "title": "ТОВ \"КАРПАТНАФТОХІМ\"",
                "pk_id": "5672"
            },
            {
                "id": 5766,
                "title": "ФГ \"Подільська  марка\"",
                "pk_id": "5766"
            },
            {
                "id": 5839,
                "title": "ТОВ \"МАКСИМУС ЦЕНТР\"",
                "pk_id": "5839"
            },
            {
                "id": 5953,
                "title": "ТОВ \"Завод \"Горсталь\"",
                "pk_id": "5953"
            },
            {
                "id": 6072,
                "title": "ФОП Лисенко В.Ф.",
                "pk_id": "6072"
            },
            {
                "id": 6204,
                "title": "ТОВ \"ГОЛДВАГОН\"",
                "pk_id": "6204"
            },
            {
                "id": 6226,
                "title": "ДП \"Словечанський лісгосп АПК\"",
                "pk_id": "6226"
            },
            {
                "id": 6302,
                "title": "(ДН-1) \"Р.Ф-Я \"ПРИДН. ЗАЛ.\"ПАТ \"УКРЗАЛІЗНИЦЯ\"",
                "pk_id": "6302"
            },
            {
                "id": 6302,
                "title": "(ДН-3) \"Р.Ф-Я \"ПРИДН.ЗАЛ.\" ПАТ \"УКРЗАЛІЗНИЦЯ\"",
                "pk_id": "6302"
            },
            {
                "id": 6302,
                "title": "(ДС Волноваха) р. ф-ї \"Дон.зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "6302"
            },
            {
                "id": 6302,
                "title": "ДС",
                "pk_id": "6302"
            },
            {
                "id": 6302,
                "title": "ДС Помічна, \"р. ф-я \"Одеська залізниця ПАТ \"Укрзалізниця\"",
                "pk_id": "6302"
            },
            {
                "id": 6354,
                "title": "ТОВ \"ХІМРЕСУРС\"",
                "pk_id": "6354"
            },
            {
                "id": 6789,
                "title": "ТОВ \"НВП\"ПРОМБРИКЕТ\"",
                "pk_id": "6789"
            },
            {
                "id": 6820,
                "title": "ПрАТ \"Трубний завод \"Трубосталь\"",
                "pk_id": "6820"
            },
            {
                "id": 7091,
                "title": "Метинвест Польща",
                "pk_id": "7091"
            },
            {
                "id": 7102,
                "title": "Ю.С. Стіл  Кошице (Словаччина)",
                "pk_id": "7102"
            },
            {
                "id": 7105,
                "title": "Дунафер (Угорщина)",
                "pk_id": "7105"
            },
            {
                "id": 7106,
                "title": "Тринецьке Железарни (Чехія)",
                "pk_id": "7106"
            },
            {
                "id": 7110,
                "title": "Арселор Мітал Поланд СА (Польща)",
                "pk_id": "7110"
            },
            {
                "id": 7238,
                "title": "ТОВ \"Глухів-Агроінвест\"",
                "pk_id": "7238"
            },
            {
                "id": 7253,
                "title": "ПРАТ\"АКХЗ\"",
                "pk_id": "7253"
            },
            {
                "id": 7508,
                "title": "ТОВ \"КРАФТ\"",
                "pk_id": "7508"
            },
            {
                "id": 7932,
                "title": "ПАТ \"АРСЕЛОРМІТТАЛ КРИВИЙ РІГ\"",
                "pk_id": "7932"
            },
            {
                "id": 7958,
                "title": "ТОВ \"СМАРТ-МЕРІТАЙМ ГРУП\"",
                "pk_id": "7958"
            },
            {
                "id": 8041,
                "title": "ТОВ \" УАПГ\"",
                "pk_id": "8041"
            },
            {
                "id": 8124,
                "title": "ПАТ \"Крюківський  вагонобудівний завод\"",
                "pk_id": "8124"
            },
            {
                "id": 8147,
                "title": "Філія ТОВ \"МЕТІНВЕСТ-СМЦ\" у в Харків",
                "pk_id": "8147"
            },
            {
                "id": 8556,
                "title": "АТ \"Укрзалізниця\"/філія \"ЦТЛ\" АТ \"Укрзалізниця\"",
                "pk_id": "8556"
            },
            {
                "id": 8602,
                "title": "ТОВ \"ТОР ТРАНС\"",
                "pk_id": "8602"
            },
            {
                "id": 8710,
                "title": "ТОВ \"УЗК\"",
                "pk_id": "8710"
            },
            {
                "id": 8719,
                "title": "ПП \"Фенікс Агро\"",
                "pk_id": "8719"
            },
            {
                "id": 8887,
                "title": "ПрАТ \"ДТЕК ПАВЛОГРАДВУГІЛЛЯ\"",
                "pk_id": "8887"
            },
            {
                "id": 8913,
                "title": "ТДВ \"ПОПАСНЯНСЬКИЙ ВРЗ\"",
                "pk_id": "8913"
            },
            {
                "id": 8915,
                "title": "ТОВ \"МЕТІНВЕСТ-ШІППІНГ\"",
                "pk_id": "8915"
            },
            {
                "id": 9120,
                "title": "ТОВ \"УЛЯНІВКА-АГРО\"",
                "pk_id": "9120"
            },
            {
                "id": 9130,
                "title": "ТОВ \"УТЗ\"",
                "pk_id": "9130"
            },
            {
                "id": 9403,
                "title": "ФОП Луценко Євгеній Анатолійович",
                "pk_id": "9403"
            },
            {
                "id": 9657,
                "title": "ТОВ \"ВТ-Сервіс\"",
                "pk_id": "9657"
            },
            {
                "id": 9713,
                "title": "(ДРЗП) ф-ї \"ЦБРК\" АТ \"УЗ\"",
                "pk_id": "9713"
            }
        ]
    },
    {
        "name": "Nazvotpr",
        "masterkey": "id",
        "rows": [
            {
                "id": 1070,
                "title": "ТОВ з іноземними інвестиціями\"Трансінвестсервіс\"",
                "pk_id": "1070"
            },
            {
                "id": 1111,
                "title": "ДП \"ВК \"КРАСНОЛИМАНСЬКА\"",
                "pk_id": "1111"
            },
            {
                "id": 1120,
                "title": "ПрАТ \"Тернопільський кар’єр\"",
                "pk_id": "1120"
            },
            {
                "id": 1206,
                "title": "СП ПРАТ \"ММК ІМ.ІЛЛІЧА\" ГЗК \"УКРМЕХАНОБР\"",
                "pk_id": "1206"
            },
            {
                "id": 1288,
                "title": "АТ \"КРИВБАСЗАЛІЗРУДКОМ\"",
                "pk_id": "1288"
            },
            {
                "id": 1335,
                "title": "ТОВ \"ЦУП ТРАНС\"",
                "pk_id": "1335"
            },
            {
                "id": 136,
                "title": "ТОВ \"Лемтранс\"",
                "pk_id": "136"
            },
            {
                "id": 1567,
                "title": "ТОВ \"НКТЛ\"",
                "pk_id": "1567"
            },
            {
                "id": 1567,
                "title": "ФОП  ФЕДОРЧУК ІГОР АНАТОЛІЙОВИЧ",
                "pk_id": "1567"
            },
            {
                "id": 1581,
                "title": "ТОВ \"Дісконт\"",
                "pk_id": "1581"
            },
            {
                "id": 1581,
                "title": "ТОВ \"СПЕЦТЕХТРАНС\"",
                "pk_id": "1581"
            },
            {
                "id": 1597,
                "title": "ДП \"Колківський лісгосп\"",
                "pk_id": "1597"
            },
            {
                "id": 209,
                "title": "ПРАТ \"КРРП\"",
                "pk_id": "209"
            },
            {
                "id": 2107,
                "title": "АТ \"ДТЕК ДОБРОПІЛЬСЬКА ЦЗФ\"",
                "pk_id": "2107"
            },
            {
                "id": 2297,
                "title": "ТОВ \"ВТГ РЕЙЛ ЛОГІСТІКС УКРАЇНА\"",
                "pk_id": "2297"
            },
            {
                "id": 2297,
                "title": "ТОВ \"Долинська Нафтопродукти\"",
                "pk_id": "2297"
            },
            {
                "id": 231,
                "title": "ДП \"БЕРДЯНСЬКИЙ  МОРСЬКИЙ ТОРГОВЕЛЬНИЙ ПОРТ\"",
                "pk_id": "231"
            },
            {
                "id": 2501,
                "title": "ТОВ \"ЮНІСТІЛ\"",
                "pk_id": "2501"
            },
            {
                "id": 2528,
                "title": "ТОВ   \"МЕТІНВЕСТ-СМЦ\" ДНІПРОВСЬКА ФІЛІЯ",
                "pk_id": "2528"
            },
            {
                "id": 2606,
                "title": "ТОВ \"РУДОМАЙН\"",
                "pk_id": "2606"
            },
            {
                "id": 2999,
                "title": "ТОВ \"ТОРГДЖОЙН ПЛЮС\"",
                "pk_id": "2999"
            },
            {
                "id": 300,
                "title": "ТОВ\"ПОРТІНВЕСТ ЛОДЖИСТІК\"",
                "pk_id": "300"
            },
            {
                "id": 3058,
                "title": "ТОВ \"УКРМЕТ ЦЕНТР\"",
                "pk_id": "3058"
            },
            {
                "id": 3128,
                "title": "ПАТ \"ДНIПРОВСЬКИЙ МЕТКОМБIНАТ\"",
                "pk_id": "3128"
            },
            {
                "id": 3134,
                "title": "ПРАТ \"ММК ІМ. ІЛЛІЧА\"",
                "pk_id": "3134"
            },
            {
                "id": 3168,
                "title": "ПРАТ \" КАМЕТ-СТАЛЬ\"",
                "pk_id": "3168"
            },
            {
                "id": 3168,
                "title": "ПРАТ \"МК \"АЗОВСТАЛЬ\"",
                "pk_id": "3168"
            },
            {
                "id": 3236,
                "title": "ПРАТ \"ЮЖКОКС\"",
                "pk_id": "3236"
            },
            {
                "id": 3437,
                "title": "ПАТ \"Алчевський металургійний комбінат\"",
                "pk_id": "3437"
            },
            {
                "id": 3512,
                "title": "ПРАТ \"ЗАПОРІЖВОГНЕТРИВ\"",
                "pk_id": "3512"
            },
            {
                "id": 3700,
                "title": "ТОВ ВК \"ГІРНИЧОДОБУВНА ПРОМИСЛОВІСТЬ\"",
                "pk_id": "3700"
            },
            {
                "id": 3857,
                "title": "ПРАТ \"ЗАПОРІЖКОКС\"",
                "pk_id": "3857"
            },
            {
                "id": 386,
                "title": "ТОВ \"АВ метал груп\"",
                "pk_id": "386"
            },
            {
                "id": 3889,
                "title": "АТ \"Інтерпайп НМТЗ\"",
                "pk_id": "3889"
            },
            {
                "id": 3925,
                "title": "ТОВ \"ПКПФ - Україна\"",
                "pk_id": "3925"
            },
            {
                "id": 4026,
                "title": "ПрАТ \"ВАВК\"",
                "pk_id": "4026"
            },
            {
                "id": 4198,
                "title": "ТОВ УГСП \"АФІНИ\"",
                "pk_id": "4198"
            },
            {
                "id": 4257,
                "title": "ФОП Торянік В.В.",
                "pk_id": "4257"
            },
            {
                "id": 4291,
                "title": "ТОВ \"ТРАНС-ІСТ КАРГО\"",
                "pk_id": "4291"
            },
            {
                "id": 4427,
                "title": "ТОВ \"Інвест Юнітрейд\"",
                "pk_id": "4427"
            },
            {
                "id": 4456,
                "title": "КП \"ЛЗ ЗБВ\"",
                "pk_id": "4456"
            },
            {
                "id": 4623,
                "title": "КП \"Фірма \"Азовбудматеріали\"",
                "pk_id": "4623"
            },
            {
                "id": 4679,
                "title": "ТОВ ф. \"ЕПЗ\"",
                "pk_id": "4679"
            },
            {
                "id": 4716,
                "title": "ПрАТ \"ЦЗФ \"РОСІЯ\"",
                "pk_id": "4716"
            },
            {
                "id": 4742,
                "title": "ТОВ \"ЗБАГАЧУВАЛЬНА ФАБРИКА \"СВЯТО-ВАРВАРИНСЬКА\"",
                "pk_id": "4742"
            },
            {
                "id": 4788,
                "title": "ПрАТ \"Вторкольормет\"",
                "pk_id": "4788"
            },
            {
                "id": 4809,
                "title": "ТзОВ \"АС-ХОЛДИНГ\"",
                "pk_id": "4809"
            },
            {
                "id": 4945,
                "title": "ПрАТ \"ЗЗРК\"",
                "pk_id": "4945"
            },
            {
                "id": 5034,
                "title": "ТОВ \"ПКФ ЄВРОСТАР\"",
                "pk_id": "5034"
            },
            {
                "id": 5068,
                "title": "ПАТ \"Запоріжсталь\"",
                "pk_id": "5068"
            },
            {
                "id": 5275,
                "title": "ТОВ \"УКРАЇНСЬКА ТРАНСПОРТНА ЕКСПЕДИЦІЯ\"",
                "pk_id": "5275"
            },
            {
                "id": 5343,
                "title": "АТ \"ПIВДГЗК\"",
                "pk_id": "5343"
            },
            {
                "id": 5344,
                "title": "ПРАТ \"ПIВНГЗК\"",
                "pk_id": "5344"
            },
            {
                "id": 5346,
                "title": "ПРАТ \"ЦЕНТРАЛЬНИЙ ГЗК\"",
                "pk_id": "5346"
            },
            {
                "id": 5347,
                "title": "ПрАТ \"Миколаївська ТЕЦ\"",
                "pk_id": "5347"
            },
            {
                "id": 5350,
                "title": "ТОВ \"ІТЕРІС\"",
                "pk_id": "5350"
            },
            {
                "id": 5350,
                "title": "ТОВ \"ТЕХНОФЕР\"",
                "pk_id": "5350"
            },
            {
                "id": 5395,
                "title": "ТОВ \"ДЗБМ\"",
                "pk_id": "5395"
            },
            {
                "id": 5493,
                "title": "ТОВ \"Придніпровська транспортно експедиційна компанія\"",
                "pk_id": "5493"
            },
            {
                "id": 5528,
                "title": "ТОВ \"ГАЛТЕХНОПАРК\"",
                "pk_id": "5528"
            },
            {
                "id": 5555,
                "title": "ТОВ \"Модуль - Україна\"",
                "pk_id": "5555"
            },
            {
                "id": 5874,
                "title": "МКСП \"ШЛЯХБУД\"",
                "pk_id": "5874"
            },
            {
                "id": 6049,
                "title": "ТОВ \"УКРПРОМ - БУД\"",
                "pk_id": "6049"
            },
            {
                "id": 6302,
                "title": "ДС",
                "pk_id": "6302"
            },
            {
                "id": 6358,
                "title": "ТОВ \"МЖК-АЛЬЯНС\"",
                "pk_id": "6358"
            },
            {
                "id": 6390,
                "title": "ПП \"Вінмасттрейд\"",
                "pk_id": "6390"
            },
            {
                "id": 6598,
                "title": "ПрАТ \"ЗМК УКРСТАЛЬ ДНІПРО\"",
                "pk_id": "6598"
            },
            {
                "id": 6653,
                "title": "ТОВ «ІНТЕРТРАНС-Д»",
                "pk_id": "6653"
            },
            {
                "id": 6820,
                "title": "ПрАТ \"Трубний завод \"Трубосталь\"",
                "pk_id": "6820"
            },
            {
                "id": 6838,
                "title": "ТОВ \"ОВРУЧ СТОУН\"",
                "pk_id": "6838"
            },
            {
                "id": 6979,
                "title": "ПРАТ \"НОВОТРОЇЦЬКЕ РУ\"",
                "pk_id": "6979"
            },
            {
                "id": 7033,
                "title": "ПРАТ \"ТОВКАЧІВСЬКИЙ ГЗК\"",
                "pk_id": "7033"
            },
            {
                "id": 7041,
                "title": "ПРАТ \"СУХА БАЛКА\"",
                "pk_id": "7041"
            },
            {
                "id": 7092,
                "title": "ТОВ \"КОРАС ПРОМ МЕТ\"",
                "pk_id": "7092"
            },
            {
                "id": 7172,
                "title": "ТОВ \"ІНДУСТРІАЛЬНО-ПРОМИСЛОВА КОМПАНІЯ \"АЛЬЯНС\"",
                "pk_id": "7172"
            },
            {
                "id": 7203,
                "title": "ТОВ «СІК»",
                "pk_id": "7203"
            },
            {
                "id": 7238,
                "title": "ТОВ \"Глухів-Агроінвест\"",
                "pk_id": "7238"
            },
            {
                "id": 7253,
                "title": "ПРАТ\"АКХЗ\"",
                "pk_id": "7253"
            },
            {
                "id": 7443,
                "title": "ТОВ  \"СУМСПЕЦСКЛАДРЕСУРС\"",
                "pk_id": "7443"
            },
            {
                "id": 7512,
                "title": "Філія \"СВРЗ\" ПАТ \"Укрзалізниця\"",
                "pk_id": "7512"
            },
            {
                "id": 7592,
                "title": "ТОВ \"АРІГОНБУД\"",
                "pk_id": "7592"
            },
            {
                "id": 7635,
                "title": "Філія \"ПВРЗ\" ПАТ \"Укрзалізниця\"",
                "pk_id": "7635"
            },
            {
                "id": 7715,
                "title": "ФІЛІЯ \"РВК\" АТ \"УКРЗАЛІЗНИЦЯ\"",
                "pk_id": "7715"
            },
            {
                "id": 810,
                "title": "ТОВ \"СОНАТА-ЮМ\"",
                "pk_id": "810"
            },
            {
                "id": 8103,
                "title": "ДП \"Схід ГЗК\"",
                "pk_id": "8103"
            },
            {
                "id": 8183,
                "title": "ТОВ \"ЛАУДЕ.УА\"",
                "pk_id": "8183"
            },
            {
                "id": 8214,
                "title": "АТ \"ДНІПРОАЗОТ\"",
                "pk_id": "8214"
            },
            {
                "id": 8320,
                "title": "ТОВ \"Техно-Транс\"",
                "pk_id": "8320"
            },
            {
                "id": 8333,
                "title": "ТОВ \"БАЛКЕР\"",
                "pk_id": "8333"
            },
            {
                "id": 869,
                "title": "ТОВ \"Проміндустрія\"",
                "pk_id": "869"
            },
            {
                "id": 8803,
                "title": "ТОВ \"Спецвагон Транслізинг\"",
                "pk_id": "8803"
            },
            {
                "id": 8887,
                "title": "ПрАТ \"ДТЕК ПАВЛОГРАДВУГІЛЛЯ\"",
                "pk_id": "8887"
            },
            {
                "id": 8900,
                "title": "ТОВ \"ЛЕВАДА КАРГО\"",
                "pk_id": "8900"
            },
            {
                "id": 8915,
                "title": "ТОВ \"МЕТІНВЕСТ-ШІППІНГ\"",
                "pk_id": "8915"
            },
            {
                "id": 9112,
                "title": "ТОВ \"РАДАЛІС\"",
                "pk_id": "9112"
            },
            {
                "id": 9375,
                "title": "ТОВ \"УСП\"",
                "pk_id": "9375"
            },
            {
                "id": 9701,
                "title": "(КМС-6)  ф-ї \"ЦБРК\" АТ \"УЗ\"",
                "pk_id": "9701"
            },
            {
                "id": 971,
                "title": "ПП \"Агросервіc\"",
                "pk_id": "971"
            },
            {
                "id": 9724,
                "title": "(ПЧ-9) \"р. ф-я \"Півд. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9724"
            },
            {
                "id": 9725,
                "title": "(ТУ БМЕС-5) ВП \"Івано-Франківське терит.упр.\" АТ \"Укрзалізниця\"",
                "pk_id": "9725"
            },
            {
                "id": 9730,
                "title": "(ПЧ-12) \"р. ф-я \"Льв. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9730"
            },
            {
                "id": 9733,
                "title": "(ПЧ-13) \"р. ф-я \"Льв. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9733"
            },
            {
                "id": 9733,
                "title": "ПЧ-23, \"р. ф-я \"Одеська залізниця\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9733"
            },
            {
                "id": 9740,
                "title": "(ПЧ-17) \"р. ф-я \"Льв. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9740"
            },
            {
                "id": 9766,
                "title": "(ПКВЧ-9) Ф-Я \"ПАСАЖИРСЬКА КОМПАНІЯ\" АТ \"УКРЗАЛІЗНИЦЯ\"",
                "pk_id": "9766"
            },
            {
                "id": 9767,
                "title": "(ВЧДЕ-10) \"р. ф-я \"Льв. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9767"
            },
            {
                "id": 9785,
                "title": "(ВЧДР Слов'янськ) р. ф-ї \"Дон.зал.\" АТ \"УЗ\"",
                "pk_id": "9785"
            },
            {
                "id": 9791,
                "title": "(БМЕУ-1)  \"Р.Ф-Я \"ПРИДН. ЗАЛ.\"ПАТ \"УКРЗАЛІЗНИЦЯ\"",
                "pk_id": "9791"
            },
            {
                "id": 9810,
                "title": "(ВЧД-11) \"р. ф-я \"Од. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9810"
            },
            {
                "id": 9845,
                "title": "(ВЧДЕ-5) \"р. ф-я \"Льв. зал.\" ПАТ \"Укрзалізниця\"",
                "pk_id": "9845"
            }
        ]
    },
    {
        "name": "Napr",
        "masterkey": "napr_id",
        "rows": [
            {
                "id": 2,
                "title": "Отправление",
                "pk_id": "1"
            },
            {
                "id": 4,
                "title": "Прием",
                "pk_id": "2"
            }
        ]
    },
    {
        "name": "Activ",
        "masterkey": "activ_id",
        "rows": [
            {
                "id": 1,
                "title": "ЧАО ДКХЗ",
                "pk_id": "3168"
            },
            {
                "id": 5,
                "title": "ЧАО МК АЗОВСТАЛЬ",
                "pk_id": "3168"
            },
            {
                "id": 6,
                "title": "ЧАО ЮЖКОКС",
                "pk_id": "3236"
            },
            {
                "id": 7,
                "title": "ЧАО ЦГОК",
                "pk_id": "5346"
            },
            {
                "id": 8,
                "title": "ЧАО АКХЗ",
                "pk_id": "7253"
            },
            {
                "id": 12,
                "title": "ЧАО ЗКХЗ",
                "pk_id": "3857"
            },
            {
                "id": 13,
                "title": "ЧАО СЕВГОК",
                "pk_id": "5344"
            },
            {
                "id": 16,
                "title": "ПАО \"Запорожсталь\"\r\n",
                "pk_id": "5068"
            },
            {
                "id": 20,
                "title": "ЧАО \"ЗАПОРОЖКОКС\"\r\n",
                "pk_id": "3857"
            }
        ]
    },
    {
        "name": "stancPrim",
        "masterkey": "stprim_id",
        "rows": [
            {
                "id": 35000,
                "title": "ЗДОЛБУНОВ",
                "pk_id": "35000"
            },
            {
                "id": 45600,
                "title": "ЗАПОРОЖЬЕ-КАМЕНСКОЕ",
                "pk_id": "45600"
            },
            {
                "id": 48200,
                "title": "ПОКРОВСК",
                "pk_id": "48200"
            },
            {
                "id": 48500,
                "title": "АСЛАНОВО",
                "pk_id": "48500"
            },
            {
                "id": 48190,
                "title": "УДАЧНАЯ",
                "pk_id": "48190"
            },
            {
                "id": 45170,
                "title": "ПРАВДА",
                "pk_id": "45170"
            },
            {
                "id": 46000,
                "title": "ЗАПОРОЖЬЕ-ЛЕВОЕ",
                "pk_id": "46000"
            },
            {
                "id": 46720,
                "title": "КРИВОЙ РОГ",
                "pk_id": "46720"
            },
            {
                "id": 45720,
                "title": "РЯДОВАЯ",
                "pk_id": "45720"
            },
            {
                "id": 45580,
                "title": "КАМЕНСКОЕ",
                "pk_id": "45580"
            },
            {
                "id": 45730,
                "title": "ТЕРНЫ",
                "pk_id": "45730"
            },
            {
                "id": 48470,
                "title": "МАРИУПОЛЬ",
                "pk_id": "48470"
            },
            {
                "id": 48480,
                "title": "САРТАНА",
                "pk_id": "48480"
            },
            {
                "id": 45750,
                "title": "КРАСНЫЙ ШАХТЕР",
                "pk_id": "45750"
            },
            {
                "id": 45740,
                "title": "ГРЕКОВАТАЯ",
                "pk_id": "45740"
            },
            {
                "id": 46770,
                "title": "ИНГУЛЕЦ",
                "pk_id": "46770"
            },
            {
                "id": 49090,
                "title": "ФЕНОЛЬНАЯ",
                "pk_id": "49090"
            },
            {
                "id": 48560,
                "title": "МАРИУПОЛЬ-СОРТИРОВОЧНЫЙ",
                "pk_id": "48560"
            },
            {
                "id": 48280,
                "title": "АВДЕЕВКА",
                "pk_id": "48280"
            },
            {
                "id": 45760,
                "title": "МУДРЕНАЯ",
                "pk_id": "45760"
            },
            {
                "id": 48630,
                "title": "ВЕЛИКО-АНАДОЛЬ",
                "pk_id": "48630"
            }
        ]
    },
    {
        "name": "Dor",
        "masterkey": "dor_id",
        "rows": [
            {
                "id": 1,
                "title": "ДОНЕЦКАЯ  ",
                "pk_id": "1"
            },
            {
                "id": 2,
                "title": "ЛЬВОВСКАЯ  ",
                "pk_id": "2"
            },
            {
                "id": 3,
                "title": "ОДЕССКАЯ  ",
                "pk_id": "3"
            },
            {
                "id": 4,
                "title": "ПРИДНЕПРОВСКАЯ  ",
                "pk_id": "4"
            },
            {
                "id": 5,
                "title": "ЮГО-ЗАПАДНАЯ  ",
                "pk_id": "5"
            },
            {
                "id": 6,
                "title": "ЮЖНАЯ  ",
                "pk_id": "6"
            }
        ]
      },
      {
        "name": "Oper",
        "masterkey": "oper_id",
        "rows": [
            {
                "id": 1,
                "title": "БРОС",
                "pk_id": "1"
            },
            {
                "id": 2,
                "title": "ВУ23",
                "pk_id": "2"
            },
            {
                "id": 3,
                "title": "ВУ26",
                "pk_id": "3"
            },
            {
                "id": 4,
                "title": "ГОТ",
                "pk_id": "4"
            },
            {
                "id": 5,
                "title": "ГУ-А",
                "pk_id": "5"
            },
            {
                "id": 6,
                "title": "ДОСЛ",
                "pk_id": "6"
            },
            {
                "id": 7,
                "title": "ЗАНЯ",
                "pk_id": "7"
            },
            {
                "id": 8,
                "title": "ЗДРЖ",
                "pk_id": "8"
            },
            {
                "id": 9,
                "title": "ИЗМ",
                "pk_id": "9"
            },
            {
                "id": 10,
                "title": "КОРР",
                "pk_id": "10"
            },
            {
                "id": 11,
                "title": "ОКОТ",
                "pk_id": "11"
            },
            {
                "id": 12,
                "title": "ОТОТ",
                "pk_id": "12"
            },
            {
                "id": 13,
                "title": "ОТПР",
                "pk_id": "13"
            },
            {
                "id": 14,
                "title": "ОТЦ",
                "pk_id": "14"
            },
            {
                "id": 15,
                "title": "ПАДР",
                "pk_id": "15"
            },
            {
                "id": 16,
                "title": "ПБРО",
                "pk_id": "16"
            },
            {
                "id": 17,
                "title": "ПГР2",
                "pk_id": "17"
            },
            {
                "id": 18,
                "title": "ПОГР",
                "pk_id": "18"
            },
            {
                "id": 19,
                "title": "ПРДР",
                "pk_id": "19"
            },
            {
                "id": 20,
                "title": "ПРИБ",
                "pk_id": "20"
            },
            {
                "id": 21,
                "title": "ПРИЦ",
                "pk_id": "21"
            },
            {
                "id": 22,
                "title": "ПРМ",
                "pk_id": "22"
            },
            {
                "id": 23,
                "title": "ПРОС",
                "pk_id": "23"
            },
            {
                "id": 24,
                "title": "ПРСТ",
                "pk_id": "24"
            },
            {
                "id": 25,
                "title": "РАСП",
                "pk_id": "25"
            },
            {
                "id": 26,
                "title": "РАСФ",
                "pk_id": "26"
            },
            {
                "id": 27,
                "title": "РСФП",
                "pk_id": "27"
            },
            {
                "id": 28,
                "title": "СДЧ",
                "pk_id": "28"
            },
            {
                "id": 29,
                "title": "ФОРМ",
                "pk_id": "29"
            }
        ]
      },
      {
        "name": "sostav",
        "masterkey": "sostav_id",
        "rows": [
            {
                "id": 18,
                "title": "03300+003+03941 (3)",
                "pk_id": "18"
            },
            {
                "id": 19,
                "title": "03319+264+03941 (12)",
                "pk_id": "19"
            },
            {
                "id": 25,
                "title": "32000+261+41000 (1)",
                "pk_id": "25"
            }
        ]
      },
      {
        "name": "marshrut",
        "masterkey": "marshrut_id",
        "rows": [
            {
                "id": 18,
                "title": "03300+003+03941 (3)",
                "pk_id": "18"
            },
            {
                "id": 19,
                "title": "03319+264+03941 (12)",
                "pk_id": "19"
            },
            {
                "id": 25,
                "title": "32000+261+41000 (1)",
                "pk_id": "25"
            }
        ]
    }
],
    "datafilter": {
        //activ: ["ПАО \"Запорожсталь\"\r\n"],
        activ: null,
        napr: null,
        sostav: null,
        marshrut: null,
        stancprim: null,
        oper: null,
        date: null,
        nazvpol: null,
        nazvotpr: null,
        stdis: null,
        nazvgruza: null,
        dor: null,
        nomv: null,
        marsh: null,
        single: null,
        st: 1
    },
  "is_error": 0,
  "error_text": "Ошибка при получении данных ",
  "user_message_text": ""
}
export const main_data_row_empty =
{
      'ID': null,
      'StationCode': '',
      'StationName': '',
      'incomeCount': '',
      'outgoingCount': '',
      'Lat': null,
      'Lng': null
}

export const main_data_empty =
{
  "datamain": [
  ],
  "subtabledata": [
  ],

  "is_error": 1,
  "error_text": "Ошибка при обращении к методу сервера",
  "user_message_text": ""

}

export const pick_data = 
{
  
  "is_error": 0,
  "error_text": "",
  "user_message_text": ""
}

